// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:07:12.999Z
// Property: Joralemon Street Apartments (ID: 6767906449166325)
// Collections: 16 amenities, 9 floorplans (live), 21 photos, 83 POIs, 3 reviews, 1 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166325",
  "property_external_id": "4973396",
  "property_zillow_url": "https://www.zillow.com/apartments/belleville-nj/joralemon/5XkHzj/",
  "property_apartments_url": "https://www.apartments.com/joralemon-belleville-nj/e3fbm5p/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "joralemon-street-apartments",
  "property_name": "Joralemon Street Apartments",
  "property_website_url": "https://www.joralemonapts.com/",
  "property_domain": "https://www.joralemonapts.com/",
  "property_address": "471 Joralemon Street",
  "property_full_address": "471 Joralemon St, Belleville, NJ 07109",
  "property_address_1": "471 Joralemon St",
  "property_address_2": null,
  "property_address_city": "Belleville",
  "property_address_state": "NJ",
  "property_address_zip_full": "07109-1860",
  "property_address_zip": "07109",
  "property_address_country": "US",
  "property_address_county": "Essex County",
  "property_neighborhood_address": "Upper Essex County",
  "property_address_latitude": "40.7994293",
  "property_address_longitude": "-74.1636712",
  "property_email": "Joralemon.pm@aionmanagement.com",
  "property_phone": "(973) 844-0044",
  "property_call_tracking_phone": "844-628-6231",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Joralemon Street Apartments in Belleville, NJ, where modern living meets comfort! Choose from beautifully designed one, two, or three-bedroom floor plans featuring renovated kitchens and scenic golf course views. Enjoy pet-friendly amenities, a fitness center, and engaging resident activities. Your ideal home awaits—schedule a tour today!",
  "property_long_description": "Welcome to Joralemon Street Apartments, where comfort meets convenience in the heart of Belleville, NJ! Our vibrant community offers a variety of spacious floor plans, including one, two, and three-bedroom apartments, thoughtfully designed to fit your lifestyle. At Joralemon Street, you’ll enjoy a host of premium amenities that enhance your living experience. \n\nTake advantage of our fully equipped fitness center to stay active, indulge your furry friends at our on-site dog park, and relax knowing that our dedicated on-site management team and 24-hour emergency maintenance staff are here to address your needs. Our online resident portal simplifies payments and maintenance requests, while flex rent options offer you added financial convenience. \n\nExperience additional comforts such as air conditioning, renovated kitchens, wall-to-wall carpeting, and charming views of the nearby golf course. Enjoy the ease of on-site laundry facilities, available garages, and ample storage space. Plus, our community is pet-friendly and features short-term lease options to accommodate your preferences.\n\nLocated in the vibrant city of Belleville, Joralemon Street Apartments not only provides a welcoming atmosphere but also easy access to local attractions and amenities, with Wi-Fi available in common areas that keep you connected. \n\nCome find your new home today! Browse our availability or schedule a personalized tour to explore everything our community has to offer. Your perfect apartment is just a click away!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd912-40e6-775e-9221-15f03723c096.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior of a brick apartment building with a parking lot and landscaping.",
    "public_id": "019fd912-40e6-775e-9221-15f03723c096",
    "storage_key": "property/6767906449166325/019fd912-40e6-775e-9221-15f03723c096.webp",
    "width": 1688,
    "height": 1127
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "62",
  "property_year_built": "1962",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.38709677419355",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": "700",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum 2 pets per apartment, each up to 100 lb.",
  "property_pet_policy_description": "We’re a pet-friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. There is a one-time, non-refundable pet fee of $300 and monthly pet rent is $75.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://joralemon.loftliving.com/login",
  "property_apply_now_url": "https://www.joralemonapts.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-5c33-7348-a123-95010ee95a2f.webp",
  "property_primary_logo_media": {
    "alt_text": "Joralemon Apartment Homes logo",
    "public_id": "019d0267-5c33-7348-a123-95010ee95a2f",
    "storage_key": "property/6767906449166325/019d0267-5c33-7348-a123-95010ee95a2f.webp",
    "width": 180,
    "height": 108
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0269-c15c-73ee-915f-2ee925772f90.webp",
  "property_secondary_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0269-c15c-73ee-915f-2ee925772f90",
    "storage_key": "property/6767906449166325/019d0269-c15c-73ee-915f-2ee925772f90.webp",
    "width": 598,
    "height": 250
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0269-cd8b-70e8-a596-3c5d5216aa79.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Joralemon Apartment Homes logo",
    "public_id": "019d0269-cd8b-70e8-a596-3c5d5216aa79",
    "storage_key": "property/6767906449166325/019d0269-cd8b-70e8-a596-3c5d5216aa79.webp",
    "width": 180,
    "height": 108
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0269-d748-7162-b220-fccce6a07d56.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Joralemon Apartment Homes logo",
    "public_id": "019d0269-d748-7162-b220-fccce6a07d56",
    "storage_key": "property/6767906449166325/019d0269-d748-7162-b220-fccce6a07d56.webp",
    "width": 180,
    "height": 108
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "492 - 854",
  "property_sqft_min": "492",
  "property_sqft_max": "854",
  "property_price_range": "1799 - 2288",
  "property_price_min": "1799",
  "property_price_max": "2288",
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/joralemonapts/",
  "property_instagram_url": "https://www.instagram.com/joralemonstreet/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJMz2tbaJVwokR5PeZe4QA2jE",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Cat+%26+Dog-friendly+Apartment+Rental&find_loc=Belleville%2C+NJ",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Joralemon Street Apartments",
  "property_home_romance_title": "Embrace a Life of Love in Your Perfect Apartment Home",
  "property_home_amenities_blurb": "Welcome to Joralemon Street Apartments in Belleville, NJ, where modern living meets comfort. Choose from spacious one, two, or three-bedroom floor plans and enjoy amenities like a dog park, fitness center, and on-site management. Revel in the convenience of flex rent payments and 24-hour emergency maintenance, all in a vibrant community.",
  "property_home_floorplans_blurb": "Welcome to Joralemon Street Apartments in vibrant Belleville, NJ! Offering thoughtfully designed one, two, and three-bedroom layouts, our community caters to your lifestyle. With a unique blend of comfort and style, browse our available apartment homes and find the floor plan that perfectly suits your needs today.",
  "property_home_gallery_blurb": "At Joralemon Street Apartments in Belleville, NJ, luxurious living meets modern convenience. Choose from spacious one, two, or three-bedroom floor plans with fantastic amenities like a fitness center, dog park, and renovated kitchens. With 24-hour emergency maintenance and a vibrant community atmosphere, picture yourself living in your dream space!",
  "property_home_neighborhood_blurb": "Welcome to Joralemon Street Apartments in vibrant Belleville, NJ! Enjoy spacious one to three-bedroom floor plans, surrounded by lush parks and cultural venues. Nearby gems like Branch Brook Park and the Newark Museum offer endless outdoor and artistic adventures, ensuring you never run out of things to explore right at your doorstep!",
  "property_home_reviews_blurb": "At Joralemon Street Apartments in Belleville, NJ, our residents celebrate a vibrant community enveloped in beauty. With Debbie’s attentive care and Gerard’s floral artistry, living here feels like home. As one resident says, “I highly recommend this apartment complex as a great place to live.\" Come see for yourself!",
  "property_neighborhood_blurb": "Nestled in vibrant Belleville, Joralemon Street Apartments offers easy access to local gems like Branch Brook Park and the Newark Museum of Art. With excellent schools and convenient transport options nearby, enjoy a lifestyle that balances charm and culture. Come see what awaits just beyond your doorstep!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Joralemon Street Apartments in Belleville, NJ, modern living meets comfort. Choose from stylish one, two, or three-bedroom floor plans, complemented by a dog park, fitness center, and resident activities. Enjoy the convenience of a 24-hour maintenance team, flex rent payments, and a welcoming community. Experience life unfiltered!",
  "property_applynow_blurb": "At Joralemon Street Apartments in Belleville, NJ, choose from thoughtfully designed one, two, or three-bedroom layouts. Enjoy amenities like pet-friendly spaces, a fitness center, and a scenic view of the golf course. Experience effortless living with online leasing and flexible rent payments. Secure your new home today!",
  "property_contactus_blurb": "At Joralemon Street Apartments in Belleville, NJ, we offer thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Whether you seek cozy elegance or spacious comfort, we have the perfect space for you. Have questions? Contact our leasing team today to find your ideal home!",
  "property_faqs_blurb": "At Joralemon Street Apartments in Belleville, NJ, our diverse floor plans—one, two, and three bedrooms—cater to your lifestyle needs. Curious about living here? Our FAQs page offers insight into community life, making your transition as smooth as possible. Check it out for all your essential questions!",
  "property_floorplans_blurb": "At Joralemon Street Apartments in Belleville, NJ, your ideal living space awaits. From cozy one-bedrooms to spacious three-bedrooms, our thoughtfully designed floor plans cater to every lifestyle. Embrace comfort and style—browse our available apartment homes and find the perfect fit for your next chapter!",
  "property_gallery_blurb": "At Joralemon Street Apartments in Belleville, NJ, picture life in a beautifully renovated mid-rise featuring spacious one, two, and three-bedroom floor plans. Enjoy a vibrant community with pet-friendly amenities, resident activities, and a refreshing fitness center. Experience the perfect blend of comfort and convenience—where every detail enhances your lifestyle.",
  "property_interactivemap_blurb": "Unwind at Joralemon Street Apartments in Belleville, NJ, where stylish mid-rise living meets modern comforts. Choose from one, two, or three-bedroom floor plans, complemented by a dog park, fitness center, and 24-hour emergency maintenance. Utilize our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Joralemon Street Apartments in Belleville, NJ, your furry friends are an integral part of your home. With ample space for up to two pets, each up to 100 lbs, you can live in comfort alongside your beloved companions. Enjoy a vibrant community where both you and your pets can thrive!",
  "property_referafriend_blurb": "At Joralemon Street Apartments in Belleville, NJ, our diverse floor plans—one, two, and three bedrooms— cater to every lifestyle. Share the joy of vibrant community living with those you care about. Great friends make great neighbors—refer a friend today and enhance your experience in our welcoming space!",
  "property_residentaccess_blurb": "Welcome to Joralemon Street Apartments in Belleville, NJ, where comfort meets convenience. Choose from thoughtfully designed one, two, or three-bedroom floor plans tailored to your lifestyle. Access your resident portal effortlessly to manage rent, schedule maintenance, and more. Your stylish home awaits—log in now for seamless living!",
  "property_reviews_blurb": "At Joralemon Street Apartments in Belleville, NJ, our residents rave about their experience! As one happy tenant shares, “I plan on making this my permanent home,” highlighting our community's welcoming atmosphere. With stunning landscaping and attentive staff like Debbie and Gerard, you’ll find your perfect haven here. ",
  "property_created_at": "1757006463633",
  "property_scheduletour_blurb": "At Joralemon Street Apartments in Belleville, NJ, you’ll find thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Step into a vibrant community where comfort meets convenience. Schedule a tour today and hear firsthand what our residents adore about calling this place home!",
  "property_thankyou_blurb": "Thank you for reaching out to Joralemon Street Apartments in Belleville, NJ! We offer a range of thoughtfully designed floor plans, from cozy one-bedroom to spacious three-bedroom layouts. Your inquiry is valuable to us, and our team will be in touch soon to help you find your ideal home.",
  "property_virtualtours_blurb": "Experience the charm of Joralemon Street Apartments in Belleville, NJ, where spacious one, two, and three-bedroom layouts cater to every lifestyle. Immerse yourself in our vibrant community and envision your future home. Ready for a sneak peek? Enjoy a virtual tour of our stylish apartments for rent today!",
  "property_copyright": "2025 All Rights Reserved. Joralemon Street Apartments",
  "property_seo_title_home": "Joralemon Street Apartments |  Apartments in Belleville, NJ",
  "property_seo_description_home": "Discover comfort at Joralemon Street Apartments in Belleville, NJ. Enjoy stylish one to three-bedroom layouts with pet-friendly amenities!",
  "property_seo_title_floorplans": "Floor Plans | Belleville, NJ Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Joralemon Street Apartments in Belleville, NJ. Choose from stylish one, two, or three-bedroom floor plans tailored for you!",
  "property_seo_title_amenities": "Amenities | Belleville, NJ Apartments for Rent",
  "property_seo_description_amenities": "Experience modern living at Joralemon Street Apartments in Belleville, NJ. Pet-friendly with a fitness center, on-site maintenance, and gorgeous floor plans.",
  "property_seo_title_gallery": "Gallery | Apartments in Belleville, NJ",
  "property_seo_description_gallery": "Experience the charm of Joralemon Street Apartments in Belleville, NJ. With modern amenities and stunning views, your perfect home awaits—imagine living here!",
  "property_seo_title_virtualtours": "Virtual Tours | Joralemon Apartments in Belleville, NJ",
  "property_seo_description_virtualtours": "Take a virtual tour of Joralemon Street Apartments in Belleville, NJ. Explore our newly updated one, two, and three-bedroom apartment homes online.",
  "property_seo_title_interactivemap": "Interactive Map | Joralemon Street Apartments Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Joralemon Street Apartments in Belleville, NJ! Enjoy modern amenities, a pet-friendly environment, and flexible lease options.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Belleville, NJ",
  "property_seo_description_neighborhood": "Discover Belleville at Joralemon Street Apartments! Explore local gems and vibrant living just steps from your door.",
  "property_seo_title_contact": "Contact Us | Joralemon Street Apartments",
  "property_seo_description_contact": "Reach out to Joralemon Street Apartments in Belleville, NJ! From cozy one-bedrooms to spacious three-bedrooms, our leasing team is ready to assist you!",
  "property_seo_title_faqs": "FAQs | Apartments in Belleville, NJ",
  "property_seo_description_faqs": "Discover Joralemon Street Apartments in Belleville, NJ—offering modern amenities, flexible living, and a friendly community!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Belleville, NJ",
  "property_seo_description_reviews": "Join our vibrant community at Joralemon Street Apartments in Belleville, NJ! Read resident reviews and discover your perfect home with top-notch amenities.",
  "property_seo_title_applynow": "Apply Now | Apartments in Belleville, NJ",
  "property_seo_description_applynow": "Experience modern living at Joralemon Street Apartments in Belleville, NJ. Enjoy spacious layouts, pet-friendly amenities, and a vibrant community. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Joralemon Street Apartments",
  "property_seo_description_residentaccess": "Access your Joralemon Street Apartments resident portal to conveniently pay rent, request maintenance, and enhance your living experience in Belleville, NJ!",
  "property_seo_title_referafriend": "Refer A Friend | Joralemon Street Apartments",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Joralemon Street Apartments in Belleville, NJ, and enjoy rewards together in your vibrant new home!",
  "property_seo_title_scheduletour": "Schedule a Tour | Joralemon Street Apartments",
  "property_seo_description_scheduletour": "Experience vibrant living at Joralemon Street Apartments in Belleville, NJ. Schedule your tour today and find your perfect home in our welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Joralemon Street Apartments",
  "property_seo_description_privacy": "Secure your peace of mind at Joralemon Street Apartments in Belleville, NJ. Read our privacy policy to learn how we protect your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | Joralemon Street Apartments",
  "property_seo_description_accessibility": "Discover seamless living at Joralemon Street Apartments in Belleville, NJ, where accessibility ensures everyone feels at home. Embrace inclusion!",
  "property_seo_title_sitemap": "Sitemap | Joralemon Street Apartments",
  "property_seo_description_sitemap": "Uncover the unique offerings of Joralemon Street Apartments in Belleville, NJ. Navigate our sitemap to find your perfect living space today!",
  "property_seo_title_thankyou": "Thank You | Joralemon Street Apartments",
  "property_seo_description_thankyou": "Thanks for reaching out to Joralemon Street Apartments in Belleville, NJ! Our team will be in touch soon to assist you in finding your perfect home.",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1791293623077",
  "amenities": [
    {
      "id": "custom_410520b3-1c26-4022-9c01-7122e8bd9f36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_972646a0-103b-42e0-b069-96a0e626ddc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bd25509b-4bbe-41d5-8230-796eae8f144c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1912e064-0026-4711-acf5-f84ccf5ed988",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_203252a8-15a7-4ed4-b923-845013baa9e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f1b450fe-e196-4712-adf3-b3416fb63678",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_63143761-6f07-415f-9c9e-b0e582d12dd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "external_id": "false",
      "title": "Wi-Fi in Common Areas",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_df7583ac-282e-4f73-92ed-a4fc6c408f70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "external_id": "false",
      "title": "Additional Storage Available",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3a87df8b-05e3-4138-a501-125f6c4b81fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_677429a5-df40-4665-9190-8a8ee1718bde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c6f25507-e53e-4dd5-8966-09bd3d48426a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d333689d-a3c1-4905-8255-65bc99e36ef0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "external_id": "false",
      "title": "Close to Shops & Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_50c456e1-68da-4a5c-b9ec-83c0e0fa38cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "external_id": "false",
      "title": "Carport Parking Available",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_12f39f34-4a43-48a2-83c3-5e3412e6ac82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_39c32fa5-5276-46d6-a501-bcf126f72d6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "external_id": "false",
      "title": "Garage Parking Available",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8137a329-a674-4103-a654-a3ed5ea76d39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "external_id": "false",
      "title": "Newly Renovated 1, 2 & 3 Bedroom Apartment Homes",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_225099b4-b8fb-467b-a41f-eed95ea4cd21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-3d69-70df-9663-e7229d745af0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and subway tile backsplash.",
        "public_id": "019fd923-3d69-70df-9663-e7229d745af0",
        "storage_key": "property/6767906449166325/019fd923-3d69-70df-9663-e7229d745af0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Compact white kitchen with marble-like countertop, stainless steel sink, window, and appliances. Ready to make Joralemon your home? Contact us today to learn more about our pet-friendly 1, 2, and 3-bedroom apartments for rent in Belleville, NJ. We can’t wait to welcome you home!",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/5767906449162442/6767906449166325/c57d737335f007f9f4ae7cffb5ffc685-1920w.jpg"
    },
    {
      "id": "custom_67fce90d-f934-411b-ad56-fd5a02c828ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-3cd9-717d-b63a-d9ce08f3850d.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with sofa, TV, and stainless steel appliances.",
        "public_id": "019fd923-3cd9-717d-b63a-d9ce08f3850d",
        "storage_key": "property/6767906449166325/019fd923-3cd9-717d-b63a-d9ce08f3850d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Bright living room with gray sofa, TV stand, and open kitchen with white cabinets and stainless steel appliances",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/Joralemon_POI-3_10-07-26_14_15-1920w.jpg"
    },
    {
      "id": "custom_f21b2f16-59c8-4b2c-a562-f02cad3e4a04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-3ce2-750f-a4da-68ba1dde7110.webp",
      "image_media": {
        "alt_text": "Living room with a couch, armchair, and artwork.",
        "public_id": "019fd923-3ce2-750f-a4da-68ba1dde7110",
        "storage_key": "property/6767906449166325/019fd923-3ce2-750f-a4da-68ba1dde7110.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a tufted sofa, comfortable armchair, and a collection of tasteful artwork, creating a welcoming atmosphere.",
      "link": "false",
      "alt_text": "Modern living room with beige walls, gray sofa, white rug, gallery art, and a large window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/Joralemon_POI-1_10-07-26_14_45-1920w.jpg"
    },
    {
      "id": "custom_50ba094a-52a6-4705-aa00-fa02fa46c5bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-3cc8-755e-9e27-83382c3727b1.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a sofa, armchair, entertainment center, and kitchen appliances.",
        "public_id": "019fd923-3cc8-755e-9e27-83382c3727b1",
        "storage_key": "property/6767906449166325/019fd923-3cc8-755e-9e27-83382c3727b1.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living room and modern kitchen area, perfect for relaxation and entertaining. Features a comfortable sofa, armchair, and fully equipped kitchen.",
      "link": "false",
      "alt_text": "Bright living room with gray sofa, TV, armchair, rug, and open kitchen in the background",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/Joralemon_Joralemon_POI-2_10-07-26_14_19-1920w.jpg"
    },
    {
      "id": "custom_ca64d2af-e227-4fe9-98ca-003e22d4d302",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-465a-760a-b283-26010fe3177a.webp",
      "image_media": {
        "alt_text": "A staged living room with a sofa, coffee table, and accent pillows.",
        "public_id": "019fd923-465a-760a-b283-26010fe3177a",
        "storage_key": "property/6767906449166325/019fd923-465a-760a-b283-26010fe3177a.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Comfortable living room featuring a plush sofa, modern coffee table, and tasteful decor, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Bright living room with gray sofa, round coffee table, rug, wall art, and window seat beneath a large window",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/Joralemon_POI-8_10-07-26_14_36-1920w.jpg"
    },
    {
      "id": "custom_33f0196f-7193-45b1-844d-65986d48597a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-49be-73d1-b81a-3c207fdeb2b8.webp",
      "image_media": {
        "alt_text": "Living room with couch, coffee table, side table, and artwork.",
        "public_id": "019fd923-49be-73d1-b81a-3c207fdeb2b8",
        "storage_key": "property/6767906449166325/019fd923-49be-73d1-b81a-3c207fdeb2b8.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious and bright living area featuring a comfortable couch, modern coffee table, and elegant artwork, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Bright living room with gray sofa, rug, coffee table, side table, and landscape wall art",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/Joralemon_POI-7_10-07-26_14_35-1920w.jpg"
    },
    {
      "id": "custom_2535a71b-d86a-4348-908e-0668e2918d7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-49f2-751d-979a-fc615b950059.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, two windows, and minimalist decor.",
        "public_id": "019fd923-49f2-751d-979a-fc615b950059",
        "storage_key": "property/6767906449166325/019fd923-49f2-751d-979a-fc615b950059.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Minimal bedroom with white bed, tan decor, two windows, and a small side table lamp",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/Joralemon_POI-6_10-07-26_14_18-1920w.jpg"
    },
    {
      "id": "custom_108990fd-0ac4-4d52-95a0-1f620028e723",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-4b42-74cb-a1ab-415c12655876.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, white bedding, and a brown headboard.",
        "public_id": "019fd923-4b42-74cb-a1ab-415c12655876",
        "storage_key": "property/6767906449166325/019fd923-4b42-74cb-a1ab-415c12655876.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed with crisp white linens and a stylish brown headboard. Large windows allow natural light to fill the room.",
      "link": "false",
      "alt_text": "Bright bedroom with a wooden bed, white bedding, and two windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/Joralemon_POI-10_10-07-26_13_49-1920w.jpg"
    },
    {
      "id": "custom_77b7621a-4dee-4f84-acf0-1557d8678b39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-512a-7429-9ab4-05a6dee44cd6.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel appliances including a microwave, gas range, and refrigerator, and a subway tile backsplash.",
        "public_id": "019fd923-512a-7429-9ab4-05a6dee44cd6",
        "storage_key": "property/6767906449166325/019fd923-512a-7429-9ab4-05a6dee44cd6.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A modern kitchen featuring clean white cabinetry, a subway tile backsplash, and a full suite of stainless steel appliances, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Bright white kitchen with stainless steel appliances, sink, microwave, stove, and refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/Joralemon+POI-9-1920w.jpg"
    },
    {
      "id": "custom_80596272-dd5d-4439-944e-d1a5de655e45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-53fc-740f-bc55-4b4ae0befbdb.webp",
      "image_media": {
        "alt_text": "Clean bathroom with vanity, toilet, and bathtub.",
        "public_id": "019fd923-53fc-740f-bc55-4b4ae0befbdb",
        "storage_key": "property/6767906449166325/019fd923-53fc-740f-bc55-4b4ae0befbdb.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A bright and clean bathroom featuring a modern vanity with granite countertop, a toilet, and a bathtub with shower.",
      "link": "false",
      "alt_text": "Bright white bathroom with vanity, mirror, sink, tub, and asmall window",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/Joralemon+POI-11-1920w.jpg"
    },
    {
      "id": "custom_534a43e7-df2c-4a5f-844f-53db864557c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-5551-70fe-bf4c-b72a229a92ba.webp",
      "image_media": {
        "alt_text": "Modern bathroom with marble vanity, white subway tile, and black accents.",
        "public_id": "019fd923-5551-70fe-bf4c-b72a229a92ba",
        "storage_key": "property/6767906449166325/019fd923-5551-70fe-bf4c-b72a229a92ba.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with marble vanity, white tile, and a shower curtain.",
      "link": "false",
      "alt_text": "Bright apartment bathroom with marble vanity, mirror, and toilet. Ready to make Joralemon your home? Contact us today to learn more about our pet-friendly 1, 2, and 3-bedroom apartments for rent in Belleville, NJ. We can’t wait to welcome you home!",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/5767906449162442/6767906449166325/600ef7e3beefb6bb1a3420656e9e9574-1920w.jpg"
    },
    {
      "id": "custom_389f84b1-fe46-4809-93d8-2dd5a25b6b52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-552a-7296-a93b-00d1ed8dbd55.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, stationary bikes, free weights, and a punching bag.",
        "public_id": "019fd923-552a-7296-a93b-00d1ed8dbd55",
        "storage_key": "property/6767906449166325/019fd923-552a-7296-a93b-00d1ed8dbd55.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Stay active in our community fitness center, equipped with cardio machines, weightlifting equipment, and a punching bag for your workout needs.",
      "link": "false",
      "alt_text": "Gym with treadmills, stationary bikes, free weights, and a punching bag.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/Joralemon+POI-14-1920w.jpg"
    },
    {
      "id": "custom_21b0308d-161c-4308-b8ed-44c74b0ad034",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-5ac1-71b7-a724-b523a27fa7e9.webp",
      "image_media": {
        "alt_text": "Laundry room with stacked washers and dryers, a water fountain, and a payphone.",
        "public_id": "019fd923-5ac1-71b7-a724-b523a27fa7e9",
        "storage_key": "property/6767906449166325/019fd923-5ac1-71b7-a724-b523a27fa7e9.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities make chores a breeze, featuring multiple high-efficiency washers and dryers. A water fountain and a retro payphone add to the communal amenities.",
      "link": "false",
      "alt_text": "Laundry room with stacked washers and dryers, a water fountain, and a payphone.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/Joralemon+POI-13-1920w.jpg"
    },
    {
      "id": "custom_4e64994b-5e51-4d87-8e75-ce46796385ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-5db7-743c-b907-49783416754b.webp",
      "image_media": {
        "alt_text": "Side view of apartment building with gravel yard and chain-link fence",
        "public_id": "019fd923-5db7-743c-b907-49783416754b",
        "storage_key": "property/6767906449166325/019fd923-5db7-743c-b907-49783416754b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of an apartment building with a gravel outdoor area and a fence line bordering a wooded area.",
      "link": "false",
      "alt_text": "Side view of apartment building with gravel yard and chain-link fence",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/Joralemon+POI-12-1920w.jpg"
    },
    {
      "id": "custom_32760d94-8f4a-4a6d-bf21-ecd7f6baa7e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-6230-73e9-a907-394037817eb9.webp",
      "image_media": {
        "alt_text": "Brick apartment building with manicured landscaping and parking lot.",
        "public_id": "019fd923-6230-73e9-a907-394037817eb9",
        "storage_key": "property/6767906449166325/019fd923-6230-73e9-a907-394037817eb9.webp",
        "width": 1702,
        "height": 1136
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Brick apartment building exterior with a main entrance, steps, and railings. Ready to make Joralemon your home? Contact us today to learn more about our pet-friendly 1, 2, and 3-bedroom apartments for rent in Belleville, NJ. We can’t wait to welcome you home!",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/5767906449162442/6767906449166325/e2ec2b20d450fb94bc9af9515ef9c2f3-1920w.jpg"
    },
    {
      "id": "custom_c2892bcd-cfac-480d-9c02-29ced2ecc0dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-6296-73aa-b880-dd723d19b951.webp",
      "image_media": {
        "alt_text": "Outdoor balcony with potted plants and brick buildings",
        "public_id": "019fd923-6296-73aa-b880-dd723d19b951",
        "storage_key": "property/6767906449166325/019fd923-6296-73aa-b880-dd723d19b951.webp",
        "width": 1592,
        "height": 1063
      },
      "title": "Community",
      "description": "Exterior view of a brick apartment community with a spacious terrace, railing, and decorative planters under a blue sky.",
      "link": "false",
      "alt_text": "Exterior of a brick apartment building with a wide terrace, railing, and colorful potted flowers. Ready to make Joralemon your home? Contact us today to learn more about our pet-friendly 1, 2, and 3-bedroom apartments for rent in Belleville, NJ. We can’t wait to welcome you home!",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/5767906449162442/6767906449166325/c31b07a4425db3780421187755fc486e-1920w.jpg"
    },
    {
      "id": "custom_0d62eb38-0eb7-40fd-98e1-87d75271f973",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd912-40e6-775e-9221-15f03723c096.webp",
      "image_media": {
        "alt_text": "Exterior of a brick apartment building with a parking lot and landscaping.",
        "public_id": "019fd912-40e6-775e-9221-15f03723c096",
        "storage_key": "property/6767906449166325/019fd912-40e6-775e-9221-15f03723c096.webp",
        "width": 1688,
        "height": 1127
      },
      "title": "Community",
      "description": "Exterior view of a brick multifamily community with landscaped grounds and covered parking.",
      "link": "false",
      "alt_text": "Exterior view of a brick apartment building with landscaped entry and parking area. Ready to make Joralemon your home? Contact us today to learn more about our pet-friendly 1, 2, and 3-bedroom apartments for rent in Belleville, NJ. We can’t wait to welcome you home!",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/ebcafc6fe9499668f76de2461b4ccf07-4724f89e-1920w.jpg"
    },
    {
      "id": "custom_4825aef3-46fb-48c8-b41d-8106c088ebbc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-1d5f-76a5-b930-0bed2b427541.webp",
      "image_media": {
        "alt_text": null,
        "public_id": "019fd923-1d5f-76a5-b930-0bed2b427541",
        "storage_key": "property/6767906449166325/019fd923-1d5f-76a5-b930-0bed2b427541.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "false",
      "link": "false",
      "alt_text": "false",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/Joralemon+POI-16-1920w.jpg"
    },
    {
      "id": "custom_0bb04754-8f75-42d9-bd98-b436f5779609",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-6931-73e4-bc7c-d6b5a2b80a8b.webp",
      "image_media": {
        "alt_text": "Parking lot and brick apartment buildings with trees and blue sky.",
        "public_id": "019fd923-6931-73e4-bc7c-d6b5a2b80a8b",
        "storage_key": "property/6767906449166325/019fd923-6931-73e4-bc7c-d6b5a2b80a8b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy ample parking and well-maintained brick buildings surrounded by lush greenery, offering a peaceful community setting.",
      "link": "false",
      "alt_text": "Parking lot and brick apartment buildings with trees and blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/Joralemon+POI-15-1920w.jpg"
    },
    {
      "id": "custom_b798bbdf-b473-4446-bbbf-5a22e13ba0c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-6c60-7229-a91a-4d8f6d5a190e.webp",
      "image_media": {
        "alt_text": "Outdoor fountain and landscaping with apartment buildings and cars in the background.",
        "public_id": "019fd923-6c60-7229-a91a-4d8f6d5a190e",
        "storage_key": "property/6767906449166325/019fd923-6c60-7229-a91a-4d8f6d5a190e.webp",
        "width": 1523,
        "height": 1017
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Exterior courtyard with a stone fountain, flowering shrubs, and parked cars.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/5767906449162442/6767906449166325/91bd186a5efb44ae79db4e33f54f7a18-1920w.jpg"
    },
    {
      "id": "custom_7a9cc8f7-9dc8-4d95-bff6-0c0a97979788",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-6f56-703f-9468-49b857df989a.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings adjacent to a golf course and suburban neighborhood.",
        "public_id": "019fd923-6f56-703f-9468-49b857df989a",
        "storage_key": "property/6767906449166325/019fd923-6f56-703f-9468-49b857df989a.webp",
        "width": 1521,
        "height": 855
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Aerial view of a multifamily apartment complex along a street beside a large green park. Ready to make Joralemon your home? Contact us today to learn more about our pet-friendly 1, 2, and 3-bedroom apartments for rent in Belleville, NJ. We can’t wait to welcome you home!",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e60e9601/dms3rep/multi/opt/5767906449162442/6767906449166325/8bb7a266921601dfa58a7106beeebb49-1920w.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_8d1fc40c-d452-44a1-b8de-64b7fd4e99cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Michael's Roscommon House",
      "poi_type": "Restaurants",
      "poi_address": "531 Joralemon St, Belleville, NJ 07109, USA",
      "poi_short_description": "Family-owned sports tavern with many TVs, a pub menu in the dining room, separate bar & pool table.",
      "poi_long_description": "Family-owned sports tavern with many TVs, a pub menu in the dining room, separate bar & pool table.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-c13a-7629-93e5-38acdccc83dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-c13a-7629-93e5-38acdccc83dd",
        "storage_key": "property/6767906449166325/019d0267-c13a-7629-93e5-38acdccc83dd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.michaelsroscommon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17434195372198081347&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "michaels-roscommon-house",
      "poi_latitude": "40.80133840000001",
      "poi_longitude": "-74.1651069",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 973-759-0060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c5e-749f-81d5-069a445c78f3",
        "storage_key": "property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ97e2TJ9VwokRQzOgGFK08vE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_df7ddf2a-2738-4ca9-b63f-7e9098d28cd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Colias Cafe",
      "poi_type": "Restaurants",
      "poi_address": "391 Broad St, Bloomfield, NJ 07003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-c12d-735f-be50-9e9274672ead.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-c12d-735f-be50-9e9274672ead",
        "storage_key": "property/6767906449166325/019d0267-c12d-735f-be50-9e9274672ead.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.coliascafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7801541672691053573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colias-cafe",
      "poi_latitude": "40.8067695",
      "poi_longitude": "-74.19254269999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 973-321-2786",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c60-711c-ae00-9506c7d0fd49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c60-711c-ae00-9506c7d0fd49",
        "storage_key": "property/6767906449166325/019d0268-5c60-711c-ae00-9506c7d0fd49.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJfT9iZABVwokRBTQoJdGkRGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_5f235e23-7965-4278-a7e2-419ac81965fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Brix Restaurant & Pizza Bar",
      "poi_type": "Restaurants",
      "poi_address": "371 Franklin Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "Casual, brick-lined restaurant & bar serving classic Italian entrees & creative brick-oven pizzas.",
      "poi_long_description": "Casual, brick-lined restaurant & bar serving classic Italian entrees & creative brick-oven pizzas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-bf97-7199-a7fd-172fb590b9d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-bf97-7199-a7fd-172fb590b9d1",
        "storage_key": "property/6767906449166325/019d0267-bf97-7199-a7fd-172fb590b9d1.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://brixrestaurantnj.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9089681647787394996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brix-restaurant--pizza-bar",
      "poi_latitude": "40.80266049999999",
      "poi_longitude": "-74.170351",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 973-751-7001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c5e-749f-81d5-069a445c78f3",
        "storage_key": "property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbzYEyp9VwokRtEfBqUwJJX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_abc6f49e-7b0d-4645-ba19-e38b1a4d5dc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Topaz",
      "poi_type": "Restaurants",
      "poi_address": "137 Washington Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "Thai home cooking including classic dishes & house specialties in a casual setting.",
      "poi_long_description": "Thai home cooking including classic dishes & house specialties in a casual setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-c061-70af-b2c6-be50f789bdb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-c061-70af-b2c6-be50f789bdb7",
        "storage_key": "property/6767906449166325/019d0267-c061-70af-b2c6-be50f789bdb7.webp",
        "width": 1057,
        "height": 948
      },
      "poi_business_url": "https://topazthaibelleville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=572102463362539354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topaz",
      "poi_latitude": "40.7857722",
      "poi_longitude": "-74.15354719999999",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 973-759-7425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c5e-749f-81d5-069a445c78f3",
        "storage_key": "property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1dDRzLZVwokRWp_ZxyiE8Ac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_99d03530-5dab-485e-9636-650cdad8b262",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Cortaditos",
      "poi_type": "Restaurants",
      "poi_address": "140 Washington Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "Fast-casual bakery/coffee shop dishing up Cuban sandwiches, pastries, and desserts in a Havana-inspired space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-c7da-7555-b92c-25eebad1f2d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-c7da-7555-b92c-25eebad1f2d7",
        "storage_key": "property/6767906449166325/019d0267-c7da-7555-b92c-25eebad1f2d7.webp",
        "width": 1280,
        "height": 929
      },
      "poi_business_url": "https://cortaditoscoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1745920695882498552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cortaditos",
      "poi_latitude": "40.7857977",
      "poi_longitude": "-74.1529977",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 973-450-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c60-711c-ae00-9506c7d0fd49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c60-711c-ae00-9506c7d0fd49",
        "storage_key": "property/6767906449166325/019d0268-5c60-711c-ae00-9506c7d0fd49.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJLYZSzLZVwokR-EEUZJ_BOhg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_207680fd-e7b2-4403-9ac8-42dd384f915b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "La Sicilia",
      "poi_type": "Restaurants",
      "poi_address": "155 Washington Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "This unassuming local pizzeria serves basic pastas & pizza along with a tomato-laden grandma pie.",
      "poi_long_description": "This unassuming local pizzeria serves basic pastas & pizza along with a tomato-laden grandma pie.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-c7ed-7089-943d-a30e8d137ba5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-c7ed-7089-943d-a30e8d137ba5",
        "storage_key": "property/6767906449166325/019d0267-c7ed-7089-943d-a30e8d137ba5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lasicilianj.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4234752828366300999&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-sicilia",
      "poi_latitude": "40.786446",
      "poi_longitude": "-74.15348519999999",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-751-5726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c5e-749f-81d5-069a445c78f3",
        "storage_key": "property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX1EL1bZVwokRR6davkLdxDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_5693ad8c-1215-44ac-b6d0-58adef67e478",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Alberto's Restaurant & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "482 Washington Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "Pizzeria offering a menu of Argentinian specialities, steaks and calzones, with pasta options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-c802-77dd-9b2a-2e02a9d72b00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-c802-77dd-9b2a-2e02a9d72b00",
        "storage_key": "property/6767906449166325/019d0267-c802-77dd-9b2a-2e02a9d72b00.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.albertosrestaurantpizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13969518022839421616&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "albertos-restaurant--pizzeria",
      "poi_latitude": "40.79708369999999",
      "poi_longitude": "-74.1482778",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 973-751-7519",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c5e-749f-81d5-069a445c78f3",
        "storage_key": "property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbwdx7b9VwokRsMrCyqCy3cE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_98a1c0c8-62f2-45bb-af4e-e58fb8ef0c2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Belmont Tavern",
      "poi_type": "Restaurants",
      "poi_address": "12 Bloomfield Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "Homestyle Italian eats & throwback digs draw loyal locals to this neighborhood eatery. Cash only.",
      "poi_long_description": "Homestyle Italian eats & throwback digs draw loyal locals to this neighborhood eatery. Cash only.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-c7f0-766a-9a13-c9aae95041b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-c7f0-766a-9a13-c9aae95041b8",
        "storage_key": "property/6767906449166325/019d0267-c7f0-766a-9a13-c9aae95041b8.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11637116507878230349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belmont-tavern",
      "poi_latitude": "40.7750377",
      "poi_longitude": "-74.1862127",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 973-759-9609",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c5e-749f-81d5-069a445c78f3",
        "storage_key": "property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJZvW33ZVwokRTYnqzc5Xf6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_b9dca356-d04f-4074-8538-c68d25f7eb6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Solar Do Minho",
      "poi_type": "Restaurants",
      "poi_address": "15 Cleveland St, Belleville, NJ 07109, USA",
      "poi_short_description": "Family-owned place offering a modern, seasonal approach to Portuguese cuisine in an old-world space.",
      "poi_long_description": "Family-owned place offering a modern, seasonal approach to Portuguese cuisine in an old-world space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-cfd6-70dd-9d8f-fcf06e6d2a11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-cfd6-70dd-9d8f-fcf06e6d2a11",
        "storage_key": "property/6767906449166325/019d0267-cfd6-70dd-9d8f-fcf06e6d2a11.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.solardominhobelleville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7005110666279577326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "solar-do-minho",
      "poi_latitude": "40.7823239",
      "poi_longitude": "-74.1534135",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 973-844-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c5e-749f-81d5-069a445c78f3",
        "storage_key": "property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVyNIiLNVwokR7ubkSwknN2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_af932d94-4ba1-4cbf-943a-9aaabff14b8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Me & Tommy's Restaurant & Catering",
      "poi_type": "Restaurants",
      "poi_address": "4 Essex St, Belleville, NJ 07109, USA",
      "poi_short_description": "Family-friendly, casual eatery serving traditional Italian meals in an intimate setting that has a fireplace.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-cfbd-73c8-84f5-6f5a625742d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-cfbd-73c8-84f5-6f5a625742d8",
        "storage_key": "property/6767906449166325/019d0267-cfbd-73c8-84f5-6f5a625742d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.meandtommys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5200746090929074565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "me--tommys-restaurant--catering",
      "poi_latitude": "40.7943949",
      "poi_longitude": "-74.148635",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 973-302-7408",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c5e-749f-81d5-069a445c78f3",
        "storage_key": "property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOc08GL9VwokRhTHU1APDLEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_80939007-a9b2-46c2-a767-38a20d6a9cca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Algieri's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "502 Union Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "Casual eatery serving pizzas and other Italian dishes in a comfy setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-cfc7-73d0-bb26-b08b220903ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-cfc7-73d0-bb26-b08b220903ba",
        "storage_key": "property/6767906449166325/019d0267-cfc7-73d0-bb26-b08b220903ba.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.algierispizzamenu.com/?utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=10589133823507478507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "algieris-pizza",
      "poi_latitude": "40.8008451",
      "poi_longitude": "-74.1541081",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 973-751-3577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c5e-749f-81d5-069a445c78f3",
        "storage_key": "property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLweJb5ZVwokR67c83Rsp9JI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_39179409-d56e-4a62-8064-400ac35d81c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Noches de Colombia Belleville",
      "poi_type": "Restaurants",
      "poi_address": "369-371 Washington Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "Relaxed restaurant serving a lengthy menu of traditional Colombian dishes, plus shakes & juices.",
      "poi_long_description": "Relaxed restaurant serving a lengthy menu of traditional Colombian dishes, plus shakes & juices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-d1a2-778f-90ac-11247f82e807.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-d1a2-778f-90ac-11247f82e807",
        "storage_key": "property/6767906449166325/019d0267-d1a2-778f-90ac-11247f82e807.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://nochesbelleville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5046326013656701498&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "noches-de-colombia-belleville",
      "poi_latitude": "40.7933333",
      "poi_longitude": "-74.1505165",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 973-969-5131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c5e-749f-81d5-069a445c78f3",
        "storage_key": "property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB1Q1L1__wokROhrS2MUmCEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5dc06575-7636-479f-ba7e-419b250a7fbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Hometown Deli & Grill",
      "poi_type": "Restaurants",
      "poi_address": "380 Washington Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "Casual spot offering a menu of breakfast and quick bites such as sandwiches and wraps.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-d737-70d6-a238-ce641643462e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-d737-70d6-a238-ce641643462e",
        "storage_key": "property/6767906449166325/019d0267-d737-70d6-a238-ce641643462e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7202388219415633374&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hometown-deli--grill",
      "poi_latitude": "40.79360339999999",
      "poi_longitude": "-74.1499193",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 973-759-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c5e-749f-81d5-069a445c78f3",
        "storage_key": "property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtbiJK79VwokR3h26-OwF9GM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_1463dd0a-2092-4ea1-8bdd-9a7fe9118eb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Belleville deli and grocery grill",
      "poi_type": "Restaurants",
      "poi_address": "82 Overlook Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-da47-76f9-94b3-7efea7e6306d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-da47-76f9-94b3-7efea7e6306d",
        "storage_key": "property/6767906449166325/019d0267-da47-76f9-94b3-7efea7e6306d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15621356996555596121&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belleville-deli-and-grocery-grill",
      "poi_latitude": "40.7999545",
      "poi_longitude": "-74.151218",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 973-751-7199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c5e-749f-81d5-069a445c78f3",
        "storage_key": "property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlYfXwDxVwokRWWFCQWw1ytg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9d555c0c-7f73-4426-b26b-ffdc4f0cfc27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Stack Pancake & Steak House",
      "poi_type": "Restaurants",
      "poi_address": "205 River Rd, North Arlington, NJ 07031, USA",
      "poi_short_description": "Casual American joint featuring hearty breakfasts & chops in simple digs with an old-school vibe.",
      "poi_long_description": "Casual American joint featuring hearty breakfasts & chops in simple digs with an old-school vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-d9d9-77fc-ac40-547793243d97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-d9d9-77fc-ac40-547793243d97",
        "storage_key": "property/6767906449166325/019d0267-d9d9-77fc-ac40-547793243d97.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://thestackna.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10491731610697150399&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stack-pancake--steak-house",
      "poi_latitude": "40.7926476",
      "poi_longitude": "-74.1417431",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 201-991-1023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c5e-749f-81d5-069a445c78f3",
        "storage_key": "property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqcCg_sNVwokRvy9X9k8empE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_86a88248-d214-426a-b1cb-b09cf1b87af1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Krauszer's Food Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "357 Franklin Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-d9fa-735c-9668-e1b85ff451c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-d9fa-735c-9668-e1b85ff451c1",
        "storage_key": "property/6767906449166325/019d0267-d9fa-735c-9668-e1b85ff451c1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9613681379569460271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "krauszers-food-store",
      "poi_latitude": "40.8024676",
      "poi_longitude": "-74.170351",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 973-751-4647",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c69-71de-834c-9141d3db453c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c69-71de-834c-9141d3db453c",
        "storage_key": "property/6767906449166325/019d0268-5c69-71de-834c-9141d3db453c.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJYXdOyJ9VwokRL2QGfUeoaoU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_fe39251d-91a7-4f34-99c7-617885481211",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Garden Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "345 Franklin Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "Popular local vendor of fresh produce and groceries, plus dry goods, at affordable prices.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-e38c-776a-af27-0a17c53e1216.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-e38c-776a-af27-0a17c53e1216",
        "storage_key": "property/6767906449166325/019d0267-e38c-776a-af27-0a17c53e1216.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17786286077898581920&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garden-farmers-market",
      "poi_latitude": "40.8019159",
      "poi_longitude": "-74.17089399999999",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 973-751-5666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c6f-73fc-9b1e-19fcee742d98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c6f-73fc-9b1e-19fcee742d98",
        "storage_key": "property/6767906449166325/019d0268-5c6f-73fc-9b1e-19fcee742d98.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhb9B6p9VwokRoOeeuvOU1fY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_4ec3cde6-0b23-496d-a86b-b6ca88d807d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "345 Franklin Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-e30a-75bf-ac93-d54f466eb1b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-e30a-75bf-ac93-d54f466eb1b8",
        "storage_key": "property/6767906449166325/019d0267-e30a-75bf-ac93-d54f466eb1b8.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-345+franklin+ave-belleville-nj-07109/id=13718",
      "poi_directions_map_url": "https://maps.google.com/?cid=18169064247066301244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "40.8019859",
      "poi_longitude": "-74.1705848",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 973-302-8703",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6186-70ef-adc0-9bb960f380c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6186-70ef-adc0-9bb960f380c4",
        "storage_key": "property/6767906449166325/019d0268-6186-70ef-adc0-9bb960f380c4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlXZ55J9VwokRPBOjO6t7Jfw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_c47d9db9-6aa2-4ef1-adaf-4b76a7f10333",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Wawa",
      "poi_type": "Shopping & Retail",
      "poi_address": "11 Franklin Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_long_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-e19f-7735-b7d0-df36cbb721f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-e19f-7735-b7d0-df36cbb721f3",
        "storage_key": "property/6767906449166325/019d0267-e19f-7735-b7d0-df36cbb721f3.webp",
        "width": 500,
        "height": 400
      },
      "poi_business_url": "https://www.wawa.com/locations/8441?utm_source=gmblisting&utm_medium=organic&utm_campaign=locallisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=344910396576721062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa",
      "poi_latitude": "40.7884835",
      "poi_longitude": "-74.1740518",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 862-300-5508",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c5e-749f-81d5-069a445c78f3",
        "storage_key": "property/6767906449166325/019d0268-5c5e-749f-81d5-069a445c78f3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlVaWJGhVwokRpmhLoy1eyQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_679d7ad6-b20f-4f29-8738-6b947e25f306",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "QuickChek",
      "poi_type": "Shopping & Retail",
      "poi_address": "190 Cortlandt St, Belleville, NJ 07109, USA",
      "poi_short_description": "Convenience-store chain for snacks, coffee, breakfast & deli meals, along with gas-station service.",
      "poi_long_description": "Convenience-store chain for snacks, coffee, breakfast & deli meals, along with gas-station service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-e370-778e-88da-d002c93e5e79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-e370-778e-88da-d002c93e5e79",
        "storage_key": "property/6767906449166325/019d0267-e370-778e-88da-d002c93e5e79.webp",
        "width": 1059,
        "height": 1280
      },
      "poi_business_url": "http://quickchek.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2035156128230047435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quickchek",
      "poi_latitude": "40.7874637",
      "poi_longitude": "-74.15019110000001",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 973-751-9581",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c69-71de-834c-9141d3db453c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c69-71de-834c-9141d3db453c",
        "storage_key": "property/6767906449166325/019d0268-5c69-71de-834c-9141d3db453c.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJr_aM5b9VwokRy36cRbdTPhw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_03b677d2-3418-49bb-bbf4-23682fa7316a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Lidl",
      "poi_type": "Shopping & Retail",
      "poi_address": "414 Main St, Belleville, NJ 07109, USA",
      "poi_short_description": "Spacious, clean grocery chain featuring affordable options such as fresh produce, meats and bakery products, plus housewares.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-eb0c-758c-9d95-a6f893fbcdc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-eb0c-758c-9d95-a6f893fbcdc1",
        "storage_key": "property/6767906449166325/019d0267-eb0c-758c-9d95-a6f893fbcdc1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lidl.com/stores/US01482",
      "poi_directions_map_url": "https://maps.google.com/?cid=15895914109697637793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lidl",
      "poi_latitude": "40.7931284",
      "poi_longitude": "-74.1441832",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 888-654-3515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6194-71e8-bf14-7614a833743d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6194-71e8-bf14-7614a833743d",
        "storage_key": "property/6767906449166325/019d0268-6194-71e8-bf14-7614a833743d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGQXnlhtVwokRob2loKmhmdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_8f07275d-f104-46ad-a213-b146cd5ecefa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "ShopRite of Belleville",
      "poi_type": "Shopping & Retail",
      "poi_address": "726 Washington Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "Supermarket chain with brand-name & house-label groceries, plus a bakery & a deli.",
      "poi_long_description": "Supermarket chain with brand-name & house-label groceries, plus a bakery & a deli.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-ee08-77ed-be95-19c3eb216916.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-ee08-77ed-be95-19c3eb216916",
        "storage_key": "property/6767906449166325/019d0267-ee08-77ed-be95-19c3eb216916.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.shoprite.com/?utm_source=GMB&utm_medium=Local_Search&utm_campaign=dbaPlatform&utm_term=126",
      "poi_directions_map_url": "https://maps.google.com/?cid=2911652661232931676&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shoprite-of-belleville",
      "poi_latitude": "40.8048743",
      "poi_longitude": "-74.14518129999999",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 973-302-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6194-71e8-bf14-7614a833743d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6194-71e8-bf14-7614a833743d",
        "storage_key": "property/6767906449166325/019d0268-6194-71e8-bf14-7614a833743d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM82h-uxVwokRXBMcNqtEaCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c66c557f-46fb-40fe-9b00-186f20609f6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "SuperFresh Food World",
      "poi_type": "Shopping & Retail",
      "poi_address": "115 Belmont Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "Supermarket carrying produce, meats, fish & standard staples, plus deli & bakery selections.",
      "poi_long_description": "Supermarket carrying produce, meats, fish & standard staples, plus deli & bakery selections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-f23f-73cd-aaeb-278d8203d31a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-f23f-73cd-aaeb-278d8203d31a",
        "storage_key": "property/6767906449166325/019d0267-f23f-73cd-aaeb-278d8203d31a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.superfreshmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13336582627594491915&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "superfresh-food-world",
      "poi_latitude": "40.7788811",
      "poi_longitude": "-74.18422699999999",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 973-528-2638",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6194-71e8-bf14-7614a833743d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6194-71e8-bf14-7614a833743d",
        "storage_key": "property/6767906449166325/019d0268-6194-71e8-bf14-7614a833743d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6yEWWh1VwokRC1hqUz0PFbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_2529afa1-d7fb-4d4e-b12b-bfd815dff886",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "SalonCentric",
      "poi_type": "Shopping & Retail",
      "poi_address": "351 Franklin Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-f2bd-73dc-8618-3303209d518a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-f2bd-73dc-8618-3303209d518a",
        "storage_key": "property/6767906449166325/019d0267-f2bd-73dc-8618-3303209d518a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.saloncentric.com/nj/belleville/3212",
      "poi_directions_map_url": "https://maps.google.com/?cid=257168564716990111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saloncentric",
      "poi_latitude": "40.802282",
      "poi_longitude": "-74.1704103",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 973-759-4956",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c6f-73fc-9b1e-19fcee742d98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c6f-73fc-9b1e-19fcee742d98",
        "storage_key": "property/6767906449166325/019d0268-5c6f-73fc-9b1e-19fcee742d98.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnfW9xLdVwokRn25ac3KlkQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_169de0f9-c298-421f-8cce-9b18a0543f9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "216 Belleville Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-f7a5-70a9-80e7-13b15bec229a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-f7a5-70a9-80e7-13b15bec229a",
        "storage_key": "property/6767906449166325/019d0267-f7a5-70a9-80e7-13b15bec229a.webp",
        "width": 1060,
        "height": 1280
      },
      "poi_business_url": "https://www.7-eleven.com/locations/nj/belleville/216-belleville-ave-38268",
      "poi_directions_map_url": "https://maps.google.com/?cid=13615370203997873367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "40.7874834",
      "poi_longitude": "-74.1587125",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 551-225-2201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5c69-71de-834c-9141d3db453c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-5c69-71de-834c-9141d3db453c",
        "storage_key": "property/6767906449166325/019d0268-5c69-71de-834c-9141d3db453c.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJObjRa7tVwokR1yS7LhCD87w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_ef6e666c-00e3-44b4-8a06-ad60e5bde81e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Belleville Elementary School 3",
      "poi_type": "Education",
      "poi_address": "230 Joralemon St, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-f7f4-764e-a02c-1b1e94de43b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-f7f4-764e-a02c-1b1e94de43b8",
        "storage_key": "property/6767906449166325/019d0267-f7f4-764e-a02c-1b1e94de43b8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://3.bellevilleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5320152460081256479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belleville-elementary-school-3",
      "poi_latitude": "40.7951378",
      "poi_longitude": "-74.1556741",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 973-969-4341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6196-7699-97c5-b0ec54208371",
        "storage_key": "property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5QqGcbxVwokRH1gQnnn61Ek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_10aeb7ea-b4c1-4fe4-8a57-a7ae4a043840",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Belleville Elementary School 7",
      "poi_type": "Education",
      "poi_address": "20 Passaic Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-02c3-7008-8bf8-5e1ce70e37a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-02c3-7008-8bf8-5e1ce70e37a1",
        "storage_key": "property/6767906449166325/019d0268-02c3-7008-8bf8-5e1ce70e37a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://7.bellevilleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9893159163959329379&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belleville-elementary-school-7",
      "poi_latitude": "40.80125260000001",
      "poi_longitude": "-74.1637622",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 973-969-4338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6196-7699-97c5-b0ec54208371",
        "storage_key": "property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb7JXsphVwokRY0Iy6tePS4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a50339f5-7966-4d13-8e27-970da024ed54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Belleville High School",
      "poi_type": "Education",
      "poi_address": "100 Passaic Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-0094-76b9-b24a-0b977182c04d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-0094-76b9-b24a-0b977182c04d",
        "storage_key": "property/6767906449166325/019d0268-0094-76b9-b24a-0b977182c04d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://hs.bellevilleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16961683493186390467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belleville-high-school",
      "poi_latitude": "40.8026388",
      "poi_longitude": "-74.161678",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 973-969-4343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6196-7699-97c5-b0ec54208371",
        "storage_key": "property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP5S-dJlVwokRw0n7K0UBZOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_879aa3bd-176e-4d5f-b4a8-5f29fc2701c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Belleville Middle School",
      "poi_type": "Education",
      "poi_address": "279 Washington Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0267-ff8f-77ca-bef3-5b655eec66c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0267-ff8f-77ca-bef3-5b655eec66c0",
        "storage_key": "property/6767906449166325/019d0267-ff8f-77ca-bef3-5b655eec66c0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ms.bellevilleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6016935671307198835&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belleville-middle-school",
      "poi_latitude": "40.7906753",
      "poi_longitude": "-74.1522148",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-450-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6196-7699-97c5-b0ec54208371",
        "storage_key": "property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRRpLvblVwokRc2GkLB1zgFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e61e87ee-549b-47b1-9f5b-4085ddd03253",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Hornblower Early Childhood Center",
      "poi_type": "Education",
      "poi_address": "34 Ralph St, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://hecc.bellevilleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=943795933729767371&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hornblower-early-childhood-center",
      "poi_latitude": "40.78898",
      "poi_longitude": "-74.1479765",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-450-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6196-7699-97c5-b0ec54208371",
        "storage_key": "property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzViuD7hVwokRy79rumYJGQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_35a20b9c-2aaf-4024-8bf3-b86e47fa8385",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Belleville Elementary School 10",
      "poi_type": "Education",
      "poi_address": "527 Belleville Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-0051-70fa-a514-59803cb8298f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-0051-70fa-a514-59803cb8298f",
        "storage_key": "property/6767906449166325/019d0268-0051-70fa-a514-59803cb8298f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://10.bellevilleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2090870790686417230&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belleville-elementary-school-10",
      "poi_latitude": "40.7934477",
      "poi_longitude": "-74.1716165",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 973-969-4334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6196-7699-97c5-b0ec54208371",
        "storage_key": "property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb1FQSGpVwokRTqEa_udDBB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_23aeed15-f3d6-4d08-9320-9afe4208e27b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Belleville Elementary School 4",
      "poi_type": "Education",
      "poi_address": "30 Magnolia St, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-058d-704f-b08a-67078d3044b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-058d-704f-b08a-67078d3044b0",
        "storage_key": "property/6767906449166325/019d0268-058d-704f-b08a-67078d3044b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://4.bellevilleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15107622330023032998&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belleville-elementary-school-4",
      "poi_latitude": "40.7820072",
      "poi_longitude": "-74.1803008",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 973-969-4340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6196-7699-97c5-b0ec54208371",
        "storage_key": "property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLxaubf1UwokRpjjILXcOqdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_aa371f40-ed1a-4757-ab2b-57d3365ce1d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Belleville Elementary School 5",
      "poi_type": "Education",
      "poi_address": "149 Adelaide St, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-076a-7786-8de1-9904dcce7f08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-076a-7786-8de1-9904dcce7f08",
        "storage_key": "property/6767906449166325/019d0268-076a-7786-8de1-9904dcce7f08.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://5.bellevilleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4804967133849752081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belleville-elementary-school-5",
      "poi_latitude": "40.8026647",
      "poi_longitude": "-74.15639089999999",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 973-969-4339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6196-7699-97c5-b0ec54208371",
        "storage_key": "property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpSeZ5pZVwokREZKKgiasrkI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3c0a5ef2-5096-4521-9f5f-95b4314e1061",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "St Peter's School",
      "poi_type": "Education",
      "poi_address": "152 William St, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-0768-71e9-9fff-cff6565a02fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-0768-71e9-9fff-cff6565a02fa",
        "storage_key": "property/6767906449166325/019d0268-0768-71e9-9fff-cff6565a02fa.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.stpeterbelleville.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6592712082522824692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-peters-school",
      "poi_latitude": "40.7853231",
      "poi_longitude": "-74.1561536",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-759-3103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6196-7699-97c5-b0ec54208371",
        "storage_key": "property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJV-CeLFVwokR9N8ymbUEfls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_ab702ca1-8460-4f20-85a8-761217490618",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Sandy Lane Nursery School",
      "poi_type": "Education",
      "poi_address": "634 Mill St, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.sandylanenurseryschool.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18316635851097002453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sandy-lane-nursery-school",
      "poi_latitude": "40.79094000000001",
      "poi_longitude": "-74.174274",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-751-6380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6196-7699-97c5-b0ec54208371",
        "storage_key": "property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoVBnRwZVwokR1VHSyELDMf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_e1ff7b8d-ea31-44ab-a46f-5ee9f5cc5dd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "New Jersey Performing Arts Center (NJPAC)",
      "poi_type": "Entertainment",
      "poi_address": "1 Center St, Newark, NJ 07102, USA",
      "poi_short_description": "This expansive performing-arts center & event venue hosts many festivals & national acts.",
      "poi_long_description": "This expansive performing-arts center & event venue hosts many festivals & national acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-0d03-72b9-b123-0367064afc25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-0d03-72b9-b123-0367064afc25",
        "storage_key": "property/6767906449166325/019d0268-0d03-72b9-b123-0367064afc25.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.njpac.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15182802343107398380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-jersey-performing-arts-center-njpac",
      "poi_latitude": "40.7397652",
      "poi_longitude": "-74.1673071",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 888-466-5722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJacdp9oBTwokR7IriA0omtNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_6228c722-bc89-491a-866d-e96c546abef8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Prudential Center",
      "poi_type": "Entertainment",
      "poi_address": "25 Lafayette St, Newark, NJ 07102, USA",
      "poi_short_description": "Sports & entertainment arena hosts events ranging from professional sports to major-league bands.",
      "poi_long_description": "Sports & entertainment arena hosts events ranging from professional sports to major-league bands.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-0f23-74b4-a463-d5c4b394544b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-0f23-74b4-a463-d5c4b394544b",
        "storage_key": "property/6767906449166325/019d0268-0f23-74b4-a463-d5c4b394544b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.prucenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5566161528393213356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prudential-center",
      "poi_latitude": "40.733537",
      "poi_longitude": "-74.1710659",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 973-757-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0_FwmoJTwokRrKVSVmv6Pk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_85965726-3305-4eb7-8625-34424a6996a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Newark Symphony Hall",
      "poi_type": "Entertainment",
      "poi_address": "1020 Broad St, Newark, NJ 07102, USA",
      "poi_short_description": "Historic theater with striking classical architecture, hosting theater, concerts, graduations and other events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-0ee0-7548-b1f5-45c255da7b90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-0ee0-7548-b1f5-45c255da7b90",
        "storage_key": "property/6767906449166325/019d0268-0ee0-7548-b1f5-45c255da7b90.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "http://www.newarksymphonyhall.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4340198859836107861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newark-symphony-hall",
      "poi_latitude": "40.7279269",
      "poi_longitude": "-74.1760665",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 973-643-4550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRRE1qHZTwokRVSwWH957Ozw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_fc67871c-ee5e-4309-a168-85949f9108b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "The Newark Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "49 Washington St, Newark, NJ 07102, USA",
      "poi_short_description": "Displays of American art, interior decor & more, plus a planetarium & an interactive nature exhibit.",
      "poi_long_description": "Displays of American art, interior decor & more, plus a planetarium & an interactive nature exhibit.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-136e-710b-9c40-ab8cf1b911f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-136e-710b-9c40-ab8cf1b911f4",
        "storage_key": "property/6767906449166325/019d0268-136e-710b-9c40-ab8cf1b911f4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.newarkmuseumart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14055773352263420871&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-newark-museum-of-art",
      "poi_latitude": "40.7429427",
      "poi_longitude": "-74.1714034",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 973-596-6550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f9-744f-bd76-8b1597f16f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f9-744f-bd76-8b1597f16f87",
        "storage_key": "property/6767906449166325/019d0268-66f9-744f-bd76-8b1597f16f87.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5fsDD4BUwokRxwsQqWQjEMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_5c289006-66b7-4820-a9d9-0254781b0311",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Montclair Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "3 S Mountain Ave, Montclair, NJ 07042, USA",
      "poi_short_description": "Exhibits focusing on American art & Native American objects & jewelry, plus educational programs.",
      "poi_long_description": "Exhibits focusing on American art & Native American objects & jewelry, plus educational programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-12f7-761e-843f-6f689f82c116.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-12f7-761e-843f-6f689f82c116",
        "storage_key": "property/6767906449166325/019d0268-12f7-761e-843f-6f689f82c116.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.montclairartmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10208268834329868295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montclair-art-museum",
      "poi_latitude": "40.8187322",
      "poi_longitude": "-74.22434799999999",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 973-746-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f9-744f-bd76-8b1597f16f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f9-744f-bd76-8b1597f16f87",
        "storage_key": "property/6767906449166325/019d0268-66f9-744f-bd76-8b1597f16f87.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJO0e0_LGqw4kRBzjsSWsOq40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_816db7c1-709b-4a11-9066-8aae7907edf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "The Clairidge",
      "poi_type": "Entertainment",
      "poi_address": "486 Bloomfield Ave, Montclair, NJ 07042, USA",
      "poi_short_description": "Six-screen nonprofit cinema showing a wide range of films in a casual setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-14db-7716-9f71-28a8c1a6bd87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-14db-7716-9f71-28a8c1a6bd87",
        "storage_key": "property/6767906449166325/019d0268-14db-7716-9f71-28a8c1a6bd87.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.montclairfilm.org/theclairidge/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1708785554648419289&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-clairidge",
      "poi_latitude": "40.814344",
      "poi_longitude": "-74.218509",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 973-381-5588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66fb-76d4-b1b2-64856dd64656.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66fb-76d4-b1b2-64856dd64656",
        "storage_key": "property/6767906449166325/019d0268-66fb-76d4-b1b2-64856dd64656.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJbyEaNbOqw4kR2UsjjmjTthc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_3aa4fdbe-949b-4f0c-a371-c5f8cfc39326",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "The Wellmont Theater",
      "poi_type": "Entertainment",
      "poi_address": "5 Seymour St, Montclair, NJ 07042, USA",
      "poi_short_description": "Long-standing theater hosting a variety of popular musical acts, comedians & special events.",
      "poi_long_description": "Long-standing theater hosting a variety of popular musical acts, comedians & special events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-1911-7525-9188-53bcab5f2132.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-1911-7525-9188-53bcab5f2132",
        "storage_key": "property/6767906449166325/019d0268-1911-7525-9188-53bcab5f2132.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://wellmonttheater.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9902307320201315560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-wellmont-theater",
      "poi_latitude": "40.8126474",
      "poi_longitude": "-74.2166355",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 973-783-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc2GCYEtVwokR6IRZBQsQbIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_985fb7d9-0540-4616-983e-47094b7feaf1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Paper Mill Playhouse",
      "poi_type": "Entertainment",
      "poi_address": "22 Brookside Dr, Millburn, NJ 07041, USA",
      "poi_short_description": "1,200-seat theater luring big name actors to star in its takes on well-known Broadway productions.",
      "poi_long_description": "1,200-seat theater luring big name actors to star in its takes on well-known Broadway productions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-1a4c-740d-adbe-571291ae9183.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-1a4c-740d-adbe-571291ae9183",
        "storage_key": "property/6767906449166325/019d0268-1a4c-740d-adbe-571291ae9183.webp",
        "width": 1280,
        "height": 904
      },
      "poi_business_url": "http://www.papermill.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14847538689968453792&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paper-mill-playhouse",
      "poi_latitude": "40.7281503",
      "poi_longitude": "-74.309185",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 11 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 973-376-4343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTRjCnimsw4kRoDhw3MUNDc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_33c5dac4-649c-4414-8340-9615a531b9fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "The Funplex",
      "poi_type": "Entertainment",
      "poi_address": "182 NJ-10, East Hanover, NJ 07936, USA",
      "poi_short_description": "Indoor family amusement center features go-karts, laser tag, bumper cars, arcade, 4D theater & more.",
      "poi_long_description": "Indoor family amusement center features go-karts, laser tag, bumper cars, arcade, 4D theater & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-1dae-7378-a110-1a9725d173b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-1dae-7378-a110-1a9725d173b8",
        "storage_key": "property/6767906449166325/019d0268-1dae-7378-a110-1a9725d173b8.webp",
        "width": 1280,
        "height": 844
      },
      "poi_business_url": "https://thefunplex.com/east-hanover/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1574537671356355301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-funplex",
      "poi_latitude": "40.8102778",
      "poi_longitude": "-74.37722219999999",
      "poi_miles_from_property": "14.5",
      "poi_walking_minutes": "5 hours 25 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 973-428-1166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxVcS-PWow4kR5ZKqeqvh2RU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_0dc712e3-49c7-4d8a-8b1d-08bc27845ea7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Clara Maass Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Clara Maass Dr, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-1d82-762e-a921-763e1c06a011.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-1d82-762e-a921-763e1c06a011",
        "storage_key": "property/6767906449166325/019d0268-1d82-762e-a921-763e1c06a011.webp",
        "width": 516,
        "height": 386
      },
      "poi_business_url": "https://www.rwjbh.org/clara-maass-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2213950906086382722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clara-maass-medical-center",
      "poi_latitude": "40.78571729999999",
      "poi_longitude": "-74.1755244",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 973-450-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-670a-739b-b397-07b35c6e9225.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-670a-739b-b397-07b35c6e9225",
        "storage_key": "property/6767906449166325/019d0268-670a-739b-b397-07b35c6e9225.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ98enbwFVwokRgtxue56IuR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_37db601c-9f6e-4df4-ab54-ca9ed65eae60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "AFC Urgent Care Belleville",
      "poi_type": "Health and Wellness",
      "poi_address": "501 Washington Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-202a-72f5-8113-f66e93173a86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-202a-72f5-8113-f66e93173a86",
        "storage_key": "property/6767906449166325/019d0268-202a-72f5-8113-f66e93173a86.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "https://www.afcurgentcare.com/belleville/?utm_source=gmb&utm_medium=organic&utm_campaign=afc-belleville-gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=14494509854044580374&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afc-urgent-care-belleville",
      "poi_latitude": "40.7976026",
      "poi_longitude": "-74.1486085",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 862-762-0585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJETjxT5tVwokRFuq5w-rXJsk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_713ef93a-99f0-4075-921e-dc948a90ab49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Good Health Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "530 Joralemon St, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-223c-752c-be80-ac84bcab780c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-223c-752c-be80-ac84bcab780c",
        "storage_key": "property/6767906449166325/019d0268-223c-752c-be80-ac84bcab780c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mygnp.com/pharmacies/good-health-pharmacy-belleville-nj-07109/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11215095315472862347&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "good-health-pharmacy",
      "poi_latitude": "40.8016484",
      "poi_longitude": "-74.1649199",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 973-759-2761",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6186-70ef-adc0-9bb960f380c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6186-70ef-adc0-9bb960f380c4",
        "storage_key": "property/6767906449166325/019d0268-6186-70ef-adc0-9bb960f380c4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7W-ZtJhVwokRi0zo8MQFpJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_e86f49c6-1bb6-4f48-bf00-5020861bf6f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Unicare Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "122 Washington Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-22ac-769b-9059-106ac5c09d3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-22ac-769b-9059-106ac5c09d3c",
        "storage_key": "property/6767906449166325/019d0268-22ac-769b-9059-106ac5c09d3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8929939713766707000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unicare-pharmacy",
      "poi_latitude": "40.7852311",
      "poi_longitude": "-74.1532265",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 973-751-0307",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6186-70ef-adc0-9bb960f380c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6186-70ef-adc0-9bb960f380c4",
        "storage_key": "property/6767906449166325/019d0268-6186-70ef-adc0-9bb960f380c4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJadKwSrFVwokROM-3WNuE7Xs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_4950ad62-674b-4186-86f2-db197a9e69ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Belleville Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "338 Washington Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-2412-77df-88b4-c63da8d1ea26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-2412-77df-88b4-c63da8d1ea26",
        "storage_key": "property/6767906449166325/019d0268-2412-77df-88b4-c63da8d1ea26.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://bellevillepharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11183847837210129243&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belleville-pharmacy",
      "poi_latitude": "40.7923391",
      "poi_longitude": "-74.1502828",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-759-1956",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6186-70ef-adc0-9bb960f380c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6186-70ef-adc0-9bb960f380c4",
        "storage_key": "property/6767906449166325/019d0268-6186-70ef-adc0-9bb960f380c4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc0hqILlVwokRWzPudloCNZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_e4e2db61-8853-46b4-a2fc-02e9817d43f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Signature Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "471 Cortlandt St, Belleville, NJ 07109, USA",
      "poi_short_description": "Around-the-clock fitness center offering a variety of classes, plus a juice bar, tanning, and child care.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-260c-746c-b859-315eab8ccb4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-260c-746c-b859-315eab8ccb4e",
        "storage_key": "property/6767906449166325/019d0268-260c-746c-b859-315eab8ccb4e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.signaturefitnessnj.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6940533257350955708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "signature-fitness",
      "poi_latitude": "40.797573",
      "poi_longitude": "-74.1462631",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-751-6999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlcy1FMBVwokRvEIwnDm6UWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_96ecef35-c8d6-4174-bbc6-406e9eeca13b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "374 Main St, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-2858-7599-9caa-2d802a90c340.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-2858-7599-9caa-2d802a90c340",
        "storage_key": "property/6767906449166325/019d0268-2858-7599-9caa-2d802a90c340.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/belleville-nj?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11807788849019521612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.79243719999999",
      "poi_longitude": "-74.1447302",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-751-8410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf3yNMsdVwokRTIqg2GWx3aM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_87a39bc0-ec03-49ab-b6c8-cc6f1d226585",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "BFF Bootcamp",
      "poi_type": "Health and Wellness",
      "poi_address": "361 Main St, Belleville, NJ 07109, USA",
      "poi_short_description": "Workouts at this gym are personalized, challenging and varied, with a focus on overall wellness.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-291f-76a1-9d38-db7a8211b1a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-291f-76a1-9d38-db7a8211b1a5",
        "storage_key": "property/6767906449166325/019d0268-291f-76a1-9d38-db7a8211b1a5.webp",
        "width": 1272,
        "height": 715
      },
      "poi_business_url": "http://www.bffbootcamp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4847822252343193646&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bff-bootcamp",
      "poi_latitude": "40.7926372",
      "poi_longitude": "-74.1458408",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 201-720-1466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSdfu5mX_wokRLnAmVafsRkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2ab4af77-9d01-482e-b570-2a767ff7d4de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Total Balance Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "42 5th St, North Arlington, NJ 07031, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-292a-70bc-b0cb-a4402bb2c2a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-292a-70bc-b0cb-a4402bb2c2a7",
        "storage_key": "property/6767906449166325/019d0268-292a-70bc-b0cb-a4402bb2c2a7.webp",
        "width": 1259,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16915202405327347574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "total-balance-pilates",
      "poi_latitude": "40.7977728",
      "poi_longitude": "-74.127843",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 201-259-7265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6196-7699-97c5-b0ec54208371",
        "storage_key": "property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXeqn4uBVwokRdp9ekffevuo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ebc88a76-7ca3-42a3-ad4e-5442fe4e993c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Uptown Dance & Fitness Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "500 Union Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-2b6d-7689-9af2-2e0fb2906d76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-2b6d-7689-9af2-2e0fb2906d76",
        "storage_key": "property/6767906449166325/019d0268-2b6d-7689-9af2-2e0fb2906d76.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://uptown-dance-fitness-studio.ueniweb.com/?utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9871952058119233026&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uptown-dance--fitness-studio",
      "poi_latitude": "40.8006781",
      "poi_longitude": "-74.1542142",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 862-686-1766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6196-7699-97c5-b0ec54208371",
        "storage_key": "property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf6vs82FVwokRAh7izxc4AIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e81e4913-5a13-4dad-ae24-3b28a5a951d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Belleville Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "343 Belleville Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "Leafy park designed by the Olmsteds with a playground, bocce courts, ball fields & a jogging path.",
      "poi_long_description": "Leafy park designed by the Olmsteds with a playground, bocce courts, ball fields & a jogging path.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-2d8d-71ca-b815-97f9e84c1278.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-2d8d-71ca-b815-97f9e84c1278",
        "storage_key": "property/6767906449166325/019d0268-2d8d-71ca-b815-97f9e84c1278.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.essexcountyparks.org/parks/belleville-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12337325241726752580&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belleville-park",
      "poi_latitude": "40.7887199",
      "poi_longitude": "-74.16436519999999",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 973-268-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-618f-76b7-b875-fca0d7489352.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-618f-76b7-b875-fca0d7489352",
        "storage_key": "property/6767906449166325/019d0268-618f-76b7-b875-fca0d7489352.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ42qb165VwokRRFeV__D7Nqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0c0e8009-4005-491c-8882-f3f96c308254",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Belleville \"Rec House\" Recreation Office",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "407 Joralemon St, Belleville, NJ 07109, USA",
      "poi_short_description": "Recreation center with football and wrestling, among other activities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-2e4a-73f3-80f0-921c58d27205.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-2e4a-73f3-80f0-921c58d27205",
        "storage_key": "property/6767906449166325/019d0268-2e4a-73f3-80f0-921c58d27205.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.bellevillenj.org/Departments/recreation-department",
      "poi_directions_map_url": "https://maps.google.com/?cid=15300382976875239389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belleville-rec-house-recreation-office",
      "poi_latitude": "40.7970687",
      "poi_longitude": "-74.1619315",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 973-450-3422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJraPUA6NVwokR3RcVqEDhVdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_f925ccaf-af14-4182-9cf4-5afe8fe6fd81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "William Street Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "39 Schuyler St, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-2f71-771c-9bca-b688c0263fae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-2f71-771c-9bca-b688c0263fae",
        "storage_key": "property/6767906449166325/019d0268-2f71-771c-9bca-b688c0263fae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7365422365538366452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-street-park",
      "poi_latitude": "40.784718",
      "poi_longitude": "-74.1550994",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-618f-76b7-b875-fca0d7489352.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-618f-76b7-b875-fca0d7489352",
        "storage_key": "property/6767906449166325/019d0268-618f-76b7-b875-fca0d7489352.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVjsY7FVwokR9LOhJp48N2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6ae91b4d-e749-420d-aa3d-9dc6f85d6206",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Hendricks Field Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "220 Franklin Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "Longtime golf course established in 1929, offering 18 classically designed holes, plus cart rentals.",
      "poi_long_description": "Longtime golf course established in 1929, offering 18 classically designed holes, plus cart rentals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-317d-7583-800f-11802b02b990.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-317d-7583-800f-11802b02b990",
        "storage_key": "property/6767906449166325/019d0268-317d-7583-800f-11802b02b990.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://essexcountyparks.org/golf/hendricks-field-golf-course",
      "poi_directions_map_url": "https://maps.google.com/?cid=10240306642595661115&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hendricks-field-golf-course",
      "poi_latitude": "40.7971297",
      "poi_longitude": "-74.1696546",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 973-751-0178",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6ad7-7111-a934-5e9ea8142cbf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6ad7-7111-a934-5e9ea8142cbf",
        "storage_key": "property/6767906449166325/019d0268-6ad7-7111-a934-5e9ea8142cbf.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJudHeiKdVwokRO8X8zqLgHI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_358839c4-0fe7-439c-aa6b-75c82ba4d962",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Branch Brook Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "& Park Avenue, Lake St, Newark, NJ 07104, USA",
      "poi_short_description": "Scenic, 360-acre park featuring cherry trees, lakes & bridges plus bicycling & other activities.",
      "poi_long_description": "Scenic, 360-acre park featuring cherry trees, lakes & bridges plus bicycling & other activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-0c66-7793-830e-7c73038f0058.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-0c66-7793-830e-7c73038f0058",
        "storage_key": "property/6767906449166325/019d0268-0c66-7793-830e-7c73038f0058.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.essexcountyparks.org/parks/branch-brook-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14809815351080011263&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "branch-brook-park",
      "poi_latitude": "40.759629",
      "poi_longitude": "-74.1810895",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 973-268-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-618f-76b7-b875-fca0d7489352.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-618f-76b7-b875-fca0d7489352",
        "storage_key": "property/6767906449166325/019d0268-618f-76b7-b875-fca0d7489352.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc1AL0JFUwokR_0VAlpgIh80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d0590ca2-911e-4dda-a37b-fdbc1d36c05d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Brookdale Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Watchung Ave, Bloomfield, NJ 07003, USA",
      "poi_short_description": "Park offering soccer, baseball, tennis, and archery, plus a playground, and picnic facilities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-32a6-701e-952b-ae5d9b06dabc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-32a6-701e-952b-ae5d9b06dabc",
        "storage_key": "property/6767906449166325/019d0268-32a6-701e-952b-ae5d9b06dabc.webp",
        "width": 1280,
        "height": 726
      },
      "poi_business_url": "https://www.essexcountyparks.org/parks/brookdale-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=7448677437073192821&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brookdale-park",
      "poi_latitude": "40.83406790000001",
      "poi_longitude": "-74.1911408",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 973-268-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-618f-76b7-b875-fca0d7489352.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-618f-76b7-b875-fca0d7489352",
        "storage_key": "property/6767906449166325/019d0268-618f-76b7-b875-fca0d7489352.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAwaeRo__wokRdfc2C6oEX2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_05c88bf3-80c6-47b8-9664-1531a0c96ffc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Watsessing Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Bloomfield Ave &, Conger St, Bloomfield, NJ 07003, USA",
      "poi_short_description": "Multi-use recreation area featuring senior center, sports fields, off-leash dog area & river.",
      "poi_long_description": "Multi-use recreation area featuring senior center, sports fields, off-leash dog area & river.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-33ba-72fa-92aa-8dd07c6c91e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-33ba-72fa-92aa-8dd07c6c91e3",
        "storage_key": "property/6767906449166325/019d0268-33ba-72fa-92aa-8dd07c6c91e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.essexcountyparks.org/parks/watsessing-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2811009696032067828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "watsessing-park",
      "poi_latitude": "40.787067",
      "poi_longitude": "-74.20243649999999",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 973-268-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-618f-76b7-b875-fca0d7489352.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-618f-76b7-b875-fca0d7489352",
        "storage_key": "property/6767906449166325/019d0268-618f-76b7-b875-fca0d7489352.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnwwjdydVwokR9JAr2Gy2Aic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_89ac67ca-745f-48b8-8b66-686f44ef319c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Reinheimer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "40 Bloomfield Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-35fd-7311-8c3c-54721e3fe0c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-35fd-7311-8c3c-54721e3fe0c6",
        "storage_key": "property/6767906449166325/019d0268-35fd-7311-8c3c-54721e3fe0c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2283160758112738109&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reinheimer-park",
      "poi_latitude": "40.81007169999999",
      "poi_longitude": "-74.1735388",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-284-4966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-618f-76b7-b875-fca0d7489352.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-618f-76b7-b875-fca0d7489352",
        "storage_key": "property/6767906449166325/019d0268-618f-76b7-b875-fca0d7489352.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc2nWo3dVwokRPdtr4Jxqrx8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b83f0bc5-42aa-4917-b212-0095a014dfaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Yanticaw Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Passaic Ave, Nutley, NJ 07110, USA",
      "poi_short_description": "Built in 1911, this park offers baseball fields & bocce courts, plus walking paths & a playground.",
      "poi_long_description": "Built in 1911, this park offers baseball fields & bocce courts, plus walking paths & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-36a9-74a8-b3a7-bbdf640a4e3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-36a9-74a8-b3a7-bbdf640a4e3c",
        "storage_key": "property/6767906449166325/019d0268-36a9-74a8-b3a7-bbdf640a4e3c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.essexcountyparks.org/parks/yanticaw-park/about",
      "poi_directions_map_url": "https://maps.google.com/?cid=3618413997872622893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yanticaw-park",
      "poi_latitude": "40.8152292",
      "poi_longitude": "-74.157056",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-268-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-618f-76b7-b875-fca0d7489352.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-618f-76b7-b875-fca0d7489352",
        "storage_key": "property/6767906449166325/019d0268-618f-76b7-b875-fca0d7489352.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_z5uIIlVwokRLa1_IVwwNzI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e507355c-9b7c-4ea4-b720-d6796d7601b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Clearman Field",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "183 Union Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-37f3-76da-bef2-8897995bd6df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-37f3-76da-bef2-8897995bd6df",
        "storage_key": "property/6767906449166325/019d0268-37f3-76da-bef2-8897995bd6df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=786360445923542512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clearman-field",
      "poi_latitude": "40.7903209",
      "poi_longitude": "-74.15844799999999",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiZ5ew7pVwokR8MWwxKi26Qo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_2a0fef37-c83c-4bc7-93ac-a0ddb2af0bce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Washington Ave at Joralemon St",
      "poi_type": "Transportation & Transit",
      "poi_address": "Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-393f-7069-92f6-144ecbff0c25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-393f-7069-92f6-144ecbff0c25",
        "storage_key": "property/6767906449166325/019d0268-393f-7069-92f6-144ecbff0c25.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7540826857962615490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-ave-at-joralemon-st",
      "poi_latitude": "40.79363",
      "poi_longitude": "-74.15003999999999",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAbibLL9VwokRwjKWBRNmpmg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_596adaa1-e02d-4bea-b8ac-1c2ed40a4ea4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Franklin Ave at Joralemon St",
      "poi_type": "Transportation & Transit",
      "poi_address": "Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11589260090788234083&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "franklin-ave-at-joralemon-st",
      "poi_latitude": "40.80343999999999",
      "poi_longitude": "-74.169431",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX7u8tZ9VwokRY0MLaaZS1aA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_3c19da23-c112-49cc-a180-66072260632c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Silver Lake",
      "poi_type": "Transportation & Transit",
      "poi_address": "Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-3ca2-76ba-9e84-bd01303de391.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-3ca2-76ba-9e84-bd01303de391",
        "storage_key": "property/6767906449166325/019d0268-3ca2-76ba-9e84-bd01303de391.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12915780964861960426&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "silver-lake",
      "poi_latitude": "40.780287",
      "poi_longitude": "-74.180343",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrfDQ_PxUwokR6mBZV1sSPrM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_7dd1a443-f2a2-4712-8d99-754023d4b6b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Grove Street",
      "poi_type": "Transportation & Transit",
      "poi_address": "Bloomfield, NJ 07003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-3cfc-765d-a89f-472fbc4090fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-3cfc-765d-a89f-472fbc4090fe",
        "storage_key": "property/6767906449166325/019d0268-3cfc-765d-a89f-472fbc4090fe.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.njtransit.com/rg/rg_servlet.srv?hdnPageAction=TrainStationLookupFrom&selStation=38065",
      "poi_directions_map_url": "https://maps.google.com/?cid=4881168068561643779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grove-street",
      "poi_latitude": "40.7804811",
      "poi_longitude": "-74.1881052",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-65d3eNUwokRA6mYL39kvUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_7c767d48-9132-4595-823f-89e4779403b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Branch Brook Park Light Rail Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Newark, NJ 07107, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-3ef0-769a-88de-29ae3ae3a0a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-3ef0-769a-88de-29ae3ae3a0a2",
        "storage_key": "property/6767906449166325/019d0268-3ef0-769a-88de-29ae3ae3a0a2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=127733897695011784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "branch-brook-park-light-rail-station",
      "poi_latitude": "40.7795735",
      "poi_longitude": "-74.17494599999999",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbW9k9v5UwokRyCPjnU3NxQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_d607b988-6996-4704-bb53-8d47b2afa2f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Davenport Avenue",
      "poi_type": "Transportation & Transit",
      "poi_address": "Newark, NJ 07107, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-416a-73ce-a74f-a72e2a212a02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-416a-73ce-a74f-a72e2a212a02",
        "storage_key": "property/6767906449166325/019d0268-416a-73ce-a74f-a72e2a212a02.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1755360436062229856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "davenport-avenue",
      "poi_latitude": "40.7721704",
      "poi_longitude": "-74.178231",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUtlovBUwokRYJVDLARLXBg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_243830d3-56bd-4871-8e7f-72915e1b0fe5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Bloomfield",
      "poi_type": "Transportation & Transit",
      "poi_address": "Bloomfield, NJ 07003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-4344-7533-bbe1-29241ec77ffb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-4344-7533-bbe1-29241ec77ffb",
        "storage_key": "property/6767906449166325/019d0268-4344-7533-bbe1-29241ec77ffb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12458258213631437569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bloomfield",
      "poi_latitude": "40.7928027",
      "poi_longitude": "-74.1999862",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6ad7-7111-a934-6222f94e4e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6ad7-7111-a934-6222f94e4e07",
        "storage_key": "property/6767906449166325/019d0268-6ad7-7111-a934-6222f94e4e07.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5zyVhiNVwokRASuYr9af5Kw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_39a96bcb-3a52-439a-bcc6-a494ba680b33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Watsessing",
      "poi_type": "Transportation & Transit",
      "poi_address": "Bloomfield, NJ 07003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-4465-722c-ba9c-e359dc30bbb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-4465-722c-ba9c-e359dc30bbb6",
        "storage_key": "property/6767906449166325/019d0268-4465-722c-ba9c-e359dc30bbb6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.njtransit.com/rg/rg_servlet.srv?hdnPageAction=TrainStationLookupFrom&selStation=154",
      "poi_directions_map_url": "https://maps.google.com/?cid=17755849611537663008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "watsessing",
      "poi_latitude": "40.7827849",
      "poi_longitude": "-74.1984633",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6ad7-7111-a934-6222f94e4e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6ad7-7111-a934-6222f94e4e07",
        "storage_key": "property/6767906449166325/019d0268-6ad7-7111-a934-6222f94e4e07.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJR8bl495UwokRIMT1rCVzafY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_73210436-44cd-409b-981c-183adb497299",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Glen Ridge",
      "poi_type": "Transportation & Transit",
      "poi_address": "224 Ridgewood Ave, Glen Ridge, NJ 07028, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-465e-773f-a6a4-638921e3fb05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-465e-773f-a6a4-638921e3fb05",
        "storage_key": "property/6767906449166325/019d0268-465e-773f-a6a4-638921e3fb05.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7355939642012583148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glen-ridge",
      "poi_latitude": "40.8004845",
      "poi_longitude": "-74.204499",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6ad7-7111-a934-6222f94e4e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6ad7-7111-a934-6222f94e4e07",
        "storage_key": "property/6767906449166325/019d0268-6ad7-7111-a934-6222f94e4e07.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJOXu5IjpVwokR7MRfhyGMFWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_f80e5f9c-cae9-45c6-80e7-7af5f7e3860a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Newark Liberty International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "Newark International Airport St, Newark, NJ 07114, USA",
      "poi_short_description": "Opened in 1928, this airport serving the NYC area is the oldest airfield in the United States.",
      "poi_long_description": "Opened in 1928, this airport serving the NYC area is the oldest airfield in the United States.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-46ed-70a0-a3f2-a10605f5a139.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-46ed-70a0-a3f2-a10605f5a139",
        "storage_key": "property/6767906449166325/019d0268-46ed-70a0-a3f2-a10605f5a139.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.newarkairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12966905903765254790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newark-liberty-international-airport",
      "poi_latitude": "40.6884837",
      "poi_longitude": "-74.17686359999999",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 973-961-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6afc-76b8-a922-919e191d1dfe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6afc-76b8-a922-919e191d1dfe",
        "storage_key": "property/6767906449166325/019d0268-6afc-76b8-a922-919e191d1dfe.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7wzsxeFSwokRhvLXxTe087M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_8158d9e6-9fce-4f62-a414-37dc41e8f2f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Bloomfield College of Montclair State University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "467 Franklin St, Bloomfield, NJ 07003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-4a33-7017-9cff-2298bdc03d44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-4a33-7017-9cff-2298bdc03d44",
        "storage_key": "property/6767906449166325/019d0268-4a33-7017-9cff-2298bdc03d44.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.bloomfield.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1901190606031614154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bloomfield-college-of-montclair-state-university",
      "poi_latitude": "40.79519579999999",
      "poi_longitude": "-74.194833",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 973-748-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6196-7699-97c5-b0ec54208371",
        "storage_key": "property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmZapUz1VwokRyvDSgshiYho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_aef5f73f-5d8a-491f-9f72-f392b4fb90da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Rutgers University - Newark Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "195 University Ave, Newark, NJ 07102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-4b59-727c-8ce0-e509a1cf67b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-4b59-727c-8ce0-e509a1cf67b1",
        "storage_key": "property/6767906449166325/019d0268-4b59-727c-8ce0-e509a1cf67b1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.newark.rutgers.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5171754516944657165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rutgers-university---newark-campus",
      "poi_latitude": "40.7416473",
      "poi_longitude": "-74.1745558",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 973-353-1766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6196-7699-97c5-b0ec54208371",
        "storage_key": "property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCWvuQX5TwokRDRsCAFXDxUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_6cfab515-22e5-4914-baa6-16792e55d376",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "New Jersey Institute of Technology",
      "poi_type": "Major Employers & Offices",
      "poi_address": "323 Dr Martin Luther King Jr Blvd, Newark, NJ 07102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-4e89-70bf-949f-dc87f7bb2c0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-4e89-70bf-949f-dc87f7bb2c0b",
        "storage_key": "property/6767906449166325/019d0268-4e89-70bf-949f-dc87f7bb2c0b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.njit.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13365602299368005443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-jersey-institute-of-technology",
      "poi_latitude": "40.7424259",
      "poi_longitude": "-74.1784006",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 973-596-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6196-7699-97c5-b0ec54208371",
        "storage_key": "property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-ZbDmH1TwokRQ1_5LnoofLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9ff60847-5061-4951-9da1-119b89d63c13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "465 Dr Martin Luther King Jr Blvd",
      "poi_type": "Major Employers & Offices",
      "poi_address": "465 Dr Martin Luther King Jr Blvd, Newark, NJ 07102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-4e89-70bf-949f-e7fd04130630.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-4e89-70bf-949f-e7fd04130630",
        "storage_key": "property/6767906449166325/019d0268-4e89-70bf-949f-e7fd04130630.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10636859121887183461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "465-dr-martin-luther-king-jr-blvd",
      "poi_latitude": "40.7375391",
      "poi_longitude": "-74.1801894",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-66f2-7099-83b5-e11ea1351c38",
        "storage_key": "property/6767906449166325/019d0268-66f2-7099-83b5-e11ea1351c38.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWYtHcXtTwokRZYL1zQO3nZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "premise"
    },
    {
      "id": "custom_229228b3-3e56-4b22-8133-0003b3f74261",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Essex County College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "303 University Ave, Newark, NJ 07102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-500f-707b-bff1-b341cd067b7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-500f-707b-bff1-b341cd067b7c",
        "storage_key": "property/6767906449166325/019d0268-500f-707b-bff1-b341cd067b7c.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://www.essex.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15628344749256151442&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "essex-county-college",
      "poi_latitude": "40.73917",
      "poi_longitude": "-74.1797103",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 973-877-4477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6196-7699-97c5-b0ec54208371",
        "storage_key": "property/6767906449166325/019d0268-6196-7699-97c5-b0ec54208371.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwUQNaHxTwokRkhHBNr8I49g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d65fd625-1e8c-4f68-8236-14d9f0f22cbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "University Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "150 Bergen St, Newark, NJ 07103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5308-731a-8823-f16fea9f8ad8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-5308-731a-8823-f16fea9f8ad8",
        "storage_key": "property/6767906449166325/019d0268-5308-731a-8823-f16fea9f8ad8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.uhnj.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16072993549390546434&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-hospital",
      "poi_latitude": "40.740324",
      "poi_longitude": "-74.1893163",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 973-972-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-670a-739b-b397-07b35c6e9225.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-670a-739b-b397-07b35c6e9225",
        "storage_key": "property/6767906449166325/019d0268-670a-739b-b397-07b35c6e9225.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2-uIQGdTwokRAoaRjHm-Dt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_cdfc0d02-dfdf-4eae-a0f1-6033e227cc0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Newark Beth Israel Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "201 Lyons Ave, Newark, NJ 07112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-54e7-70fb-86f8-0c05da92cb76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-54e7-70fb-86f8-0c05da92cb76",
        "storage_key": "property/6767906449166325/019d0268-54e7-70fb-86f8-0c05da92cb76.webp",
        "width": 325,
        "height": 250
      },
      "poi_business_url": "https://www.rwjbh.org/newark-beth-israel-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6133321870101566139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newark-beth-israel-medical-center",
      "poi_latitude": "40.7100478",
      "poi_longitude": "-74.2125181",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 973-926-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-670a-739b-b397-07b35c6e9225.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-670a-739b-b397-07b35c6e9225",
        "storage_key": "property/6767906449166325/019d0268-670a-739b-b397-07b35c6e9225.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJFYciRypTwokRu9KJwL7vHVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_3c509c5b-3eeb-4a02-9555-21da3f669f23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Saint Michael's Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "111 Central Ave, Newark, NJ 07102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-540c-715d-8172-8daa05621f6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-540c-715d-8172-8daa05621f6a",
        "storage_key": "property/6767906449166325/019d0268-540c-715d-8172-8daa05621f6a.webp",
        "width": 700,
        "height": 366
      },
      "poi_business_url": "https://smmcnj.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9449799520372297536&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-michaels-medical-center",
      "poi_latitude": "40.7439709",
      "poi_longitude": "-74.17464939999999",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 973-877-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-670a-739b-b397-07b35c6e9225.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-670a-739b-b397-07b35c6e9225",
        "storage_key": "property/6767906449166325/019d0268-670a-739b-b397-07b35c6e9225.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJPeYX_HFTwokRQI9yuphuJIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ee9cc38c-0dbb-43c6-8a8b-9ff7cda97f33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "poi_name": "Belleville Municipal Buildings",
      "poi_type": "Major Employers & Offices",
      "poi_address": "152 Washington Ave, Belleville, NJ 07109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-5797-73a0-b6e0-11df2a1d396d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-5797-73a0-b6e0-11df2a1d396d",
        "storage_key": "property/6767906449166325/019d0268-5797-73a0-b6e0-11df2a1d396d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://bellevillenj.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=105340813349342997&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belleville-municipal-buildings",
      "poi_latitude": "40.7863353",
      "poi_longitude": "-74.1524968",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 973-450-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019d0268-6add-74e8-afa3-477dd7f3ec29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-6add-74e8-afa3-477dd7f3ec29",
        "storage_key": "property/6767906449166325/019d0268-6add-74e8-afa3-477dd7f3ec29.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2zx207ZVwokRFc8JYOk-dgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_506d101f-5190-46cc-a1ab-a78db2d7f58b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_6fedd689-7280-42d5-9fda-100f66c3a41c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f8b7da7b-16b7-4521-97f3-c9191088daa2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_07b6da01-090b-4bcf-8d02-acecc5249173",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_4ff8a574-c41b-44de-9372-c13f3d3a48da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_82cf19b98c13737ae411dfa2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "rating": "5",
      "name": "Debra Casale",
      "text": "Gerard did excellent work today making the property look so beautiful with 💐 Flowers😊",
      "date": "2025-06-04",
      "title": "false"
    },
    {
      "id": "ec_885c0c07e60ea79535fbc7e5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "rating": "5",
      "name": "Edwin Melendez",
      "text": "This is a great place to live.  Debbie is a great person, easy to talk to and listens to my concerns.   Mr G as I call him, has handled any issues that I have brought to him or Debbie in an expeditious and professional manner.\n\nI have been here just over 2 years and plan on making this my permanent home.\nMy cat Sophie  and I are very happy here.\n\nI highly recommend  this apartment  complex as a great place to live.....",
      "date": "2022-02-02",
      "title": "false"
    },
    {
      "id": "ec_73599353eb50e6c063458bb1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "rating": "5",
      "name": "Joanne Senesca",
      "text": "I have not yet moved in. I am planning on, so far  conversations that I've had with Debbie during my tour and via emails and phone has all been great. I am excited to move in as the place seems so clean and she takes really good care of the plant decor outside. I hope the carpeted room gets deep clean before I move in. I am excited to take on this journey with Joralemon Street as I am a very quiet and clean and this place seems like it matches my personality.",
      "date": "2022-10-26",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_922914cd-4209-48fd-b124-116c74da7cb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/019fd923-1d5f-76a5-b930-0bed2b427541.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd923-1d5f-76a5-b930-0bed2b427541",
        "storage_key": "property/6767906449166325/019fd923-1d5f-76a5-b930-0bed2b427541.webp",
        "width": 1280,
        "height": 853
      },
      "virtual_tour_title": "Virtual Tours",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=636901c6aafe297972731022"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a2832-98d1-7148-8205-e0bc95fc9a2b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-joralemon-street-apartments-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325"
    },
    {
      "lead_collector_id": "019c3043-6926-761a-99bd-5fa0042cc606",
      "lead_source": "FACEBOOK_ADS",
      "name": "joralemon",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325"
    },
    {
      "lead_collector_id": "019c3043-6997-763c-b18b-34b3515ed694",
      "lead_source": "LANDING_PAGE",
      "name": "joralemon",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-belleville-nj-562",
      "search_query": "pet friendly apartments Belleville NJ",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Belleville, NJ",
      "h2_subtitle": "Explore pet-friendly living at Joralemon Street Apartments in Belleville, NJ. Discover a community that welcomes both you and your furry friends.",
      "page_copy": "Embrace a lifestyle that both you and your pets will love at Joralemon Street Apartments, located in the heart of Belleville, NJ. Our pet-friendly apartments are designed for modern living with spacious floor plans and beautifully renovated kitchens. Whether you're relaxing with your pet in your one, two, or three-bedroom home or enjoying the nearby parks, you’ll find the perfect balance of comfort and convenience.\n\nAt Joralemon Street Apartments, we offer much more than just pet-friendly policies. With our on-site gym, residents can stay active, while the community activities provide engaging opportunities to socialize. Meanwhile, our 24-hour emergency maintenance ensures a worry-free living experience. Don’t just find a home; find a community that welcomes you and your pets. Schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Belleville, NJ",
      "seo_description": "Discover pet-friendly living at Joralemon Street Apartments in Belleville, NJ. Enjoy modern amenities and spacious, renovated homes.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "apartments-with-air-conditioning-essex-county-809",
      "search_query": "apartments with air conditioning Essex County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Essex County",
      "h2_subtitle": "Discover apartments with air conditioning at Joralemon Street Apartments in Essex County. Enjoy cool comfort and modern amenities in Belleville, NJ.",
      "page_copy": "Stay cool and comfortable at Joralemon Street Apartments, offering air-conditioned living spaces in the vibrant Belleville area of Essex County. Our community is designed for those seeking comfortable and stylish homes with modern features including beautifully renovated kitchens and scenic views. Choose from one, two, or three-bedroom floor plans that cater to your lifestyle needs.\n\nLocated in the welcoming town of Belleville, NJ, you'll enjoy not just air-conditioned interiors, but also a range of amenities like a fully-equipped fitness center and Wi-Fi in common areas. Engaging resident activities are a staple here, fostering a sense of community among neighbors. Experience convenience, comfort, and a welcoming environment—schedule a visit to see what makes Joralemon Street Apartments the perfect choice for your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Essex County",
      "seo_description": "Find air-conditioned living at Joralemon Street Apartments in Essex County. Enjoy modern amenities and cozy homes in Belleville, NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-near-07109-280",
      "search_query": "fitness center apartments near 07109",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center Near 07109",
      "h2_subtitle": "Discover fitness-focused living at Joralemon Street Apartments, located near 07109. Our community offers a state-of-the-art fitness center for residents.",
      "page_copy": "For those seeking a healthy lifestyle near 07109, Joralemon Street Apartments offers the perfect solution with our on-site fitness center. Located in Belleville, NJ, this vibrant community provides all the essentials for modern living with beautifully designed one, two, and three-bedroom floor plans. Whether you are starting your fitness journey or are already an enthusiast, our gym is fully equipped to meet your needs.\n\nBeyond fitness, residents enjoy amenities that promote engagement and convenience. Participate in our resident activities or relax in your beautifully renovated home with scenic views. Our pet-friendly policies ensure that every member of your family, including your furry friends, feels welcome. Experience wellness and comfort in Essex County by making Joralemon Street Apartments your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center Near 07109",
      "seo_description": "Joralemon Street Apartments near 07109 offers a fitness center and modern amenities for active living in Belleville, NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "dog-park-apartments-belleville-nj-348",
      "search_query": "dog park apartments in Belleville NJ",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Belleville, NJ",
      "h2_subtitle": "Explore dog-friendly living at Joralemon Street Apartments in Belleville, NJ. Enjoy easy access to dog parks and pet amenities.",
      "page_copy": "If you're searching for a pet-friendly haven with easy access to dog parks in Belleville, NJ, look no further than Joralemon Street Apartments. Our community caters to pet owners with spacious floor plans and beautifully renovated homes that welcome both you and your furry companions.\n\nSituated in the heart of Belleville, our apartments are just a hop away from local dog parks, perfect for playing and socializing with your pup. Enjoy a community where both pets and their owners feel at home, with amenities like a fitness center, resident activities, and Wi-Fi in common areas. Discover the ideal blend of convenience and comfort at Joralemon Street Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Belleville, NJ",
      "seo_description": "Find dog-friendly apartments in Belleville, NJ, with easy access to local dog parks at Joralemon Street Apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "apartment-with-parking-belleville-805",
      "search_query": "apartment with parking Belleville",
      "category": "Amenity",
      "h1_title": "Apartment with Parking in Belleville",
      "h2_subtitle": "Secure your spot at Joralemon Street Apartments, where parking is conveniently available. Located in the heart of Belleville, NJ, offering modern amenities.",
      "page_copy": "Finding an apartment with parking in Belleville is effortless at Joralemon Street Apartments. Nestled in this bustling NJ town, our community ensures that parking dilemmas are a thing of the past, with ample on-site parking facilities available for residents.\n\nMore than just parking, Joralemon Street Apartments provides a modern living experience with one, two, and three-bedroom options featuring renovated kitchens and scenic views. Engage with community life through resident activities or work out at our fully-equipped fitness center. Discover the convenience and comfort of living in a place that accommodates all your needs in beautiful Essex County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment with Parking in Belleville, NJ",
      "seo_description": "Discover Joralemon Street Apartments in Belleville, NJ, featuring convenient on-site parking and modern amenities for a comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-belleville-nj-604",
      "search_query": "one bedroom apartments belleville nj",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Belleville, NJ",
      "h2_subtitle": "Find your perfect one bedroom apartment at Joralemon Street Apartments in Belleville, NJ. Offering modern comforts and amenities.",
      "page_copy": "Discover the charm of living in a one-bedroom apartment at Joralemon Street Apartments, located in the vibrant Belleville, NJ area. Our thoughtfully designed one-bedroom units offer modern layouts with renovated kitchens and stunning views of the nearby golf course, ensuring a cozy yet luxurious living space.\n\nIdeal for individuals or couples, our community is not only about beautiful interiors but also about offering a dynamic lifestyle. Enjoy amenities such as a state-of-the-art fitness center, on-site parking, and a strong sense of community with engaging resident activities. Nestled in Essex County, Joralemon Street Apartments provides a perfect blend of tranquility and convenience, making it an ideal choice for anyone seeking a one-bedroom home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Belleville, NJ",
      "seo_description": "Explore modern one-bedroom apartments in Belleville, NJ, at Joralemon Street Apartments. Enjoy contemporary amenities and scenic views.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-essex-county-320",
      "search_query": "two bedroom apartments essex county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Essex County",
      "h2_subtitle": "Discover spacious two bedroom apartments at Joralemon Street Apartments in Essex County. Modern amenities in a convenient location.",
      "page_copy": "Explore the spacious living offered by the two-bedroom apartments at Joralemon Street Apartments, perfectly situated in Essex County. Our community delivers not just a place to live but a lifestyle, with beautifully renovated two-bedroom layouts that cater to comfort and modernity.\n\nEach apartment is designed with an eye for detail, featuring upgraded kitchens and access to captivating views. Located in Belleville, NJ, residents enjoy excellent connectivity within Essex County and are just minutes away from local attractions. Alongside an enriching residential experience, our community offers engaging amenities such as a fitness center, resident activities, and reliable on-site parking. Choose Joralemon Street Apartments for a perfect blend of style and convenience in your next two-bedroom home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Essex County, NJ",
      "seo_description": "Find spacious two-bedroom apartments in Essex County, NJ, at Joralemon Street Apartments, offering modern amenities and beautiful surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-07109-468",
      "search_query": "three bedroom apartments near 07109",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 07109",
      "h2_subtitle": "Explore spacious three bedroom apartments at Joralemon Street Apartments near the 07109 area, offering modern features and conveniences.",
      "page_copy": "Welcome to the ideal home for expanding families or roommates seeking three-bedroom apartments near the 07109 area. Located at Joralemon Street Apartments in Belleville, NJ, our three-bedroom spaces offer ample room with modern designs that include renovated kitchens and picturesque views.\n\nSituated conveniently near downtown Belleville, residents can enjoy quick access to local amenities and attractions. Beyond the beautiful interiors, our community boasts an array of amenities, including a fitness center, on-site parking, and engaging activities for residents. Discover the comfort and convenience of Joralemon Street Apartments, a perfect three-bedroom living choice in a vibrant neighborhood within Essex County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 07109, Belleville",
      "seo_description": "Explore three-bedroom apartments near 07109 at Joralemon Street Apartments, Belleville, NJ, offering modern amenities and spacious layouts.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "apartments-near-belleville-elementary-school-3-nj-222",
      "search_query": "apartments near Belleville Elementary School 3 NJ",
      "category": "School",
      "h1_title": "Apartments Near Belleville Elementary School 3",
      "h2_subtitle": "Discover convenient living at Joralemon Street Apartments, near Belleville Elementary School 3 in NJ. Ideal for families looking for proximity.",
      "page_copy": "Joralemon Street Apartments offers the perfect setting for families seeking convenient homes near Belleville Elementary School 3, NJ. Our community prioritizes both comfort and accessibility, with a range of modern one, two, and three-bedroom apartment layouts designed to suit various family needs.\n\nLocated in a prime Belleville location, our apartments are a quick commute from the school, making daily routines simpler for families. Residents benefit from high-end amenities including a fitness center, reliable on-site parking, and engaging community activities. Live in a neighborhood that balances casual elegance with practical convenience at Joralemon Street Apartments, situated comfortably near educational and recreational facilities in Belleville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Belleville Elementary School 3, NJ",
      "seo_description": "Find apartments near Belleville Elementary School 3, NJ at Joralemon Street Apartments, offering modern amenities and family-friendly layouts.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "belleville-elementary-school-7-nearby-apartments-746",
      "search_query": "Belleville Elementary School 7 nearby apartments",
      "category": "School",
      "h1_title": "Apartments Near Belleville Elementary School 7",
      "h2_subtitle": "Find comfortable living at Joralemon Street Apartments, located conveniently near Belleville Elementary School 7. Ideal for families in NJ.",
      "page_copy": "Looking for apartments near Belleville Elementary School 7? Joralemon Street Apartments is a top choice for families seeking a balanced lifestyle with close proximity to educational facilities. Our beautifully designed one, two, and three-bedroom layouts offer modern amenities in a welcoming environment.\n\nSituated in the heart of Belleville, Joralemon Street Apartments connects residents easily to the surrounding community and educational institutions. Enjoy amenities such as a fitness center, on-site parking, and engaging resident events that make everyday living both convenient and enjoyable. Experience the perfect combination of comfort and accessibility at Joralemon Street Apartments, just steps away from Belleville Elementary School 7.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Belleville Elementary School 7, NJ",
      "seo_description": "Discover family-friendly apartments near Belleville Elementary School 7 at Joralemon Street Apartments, offering modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "belleville-high-school-essex-county-apartments-437",
      "search_query": "Belleville High School Essex County apartments",
      "category": "School",
      "h1_title": "Apartments Near Belleville High School",
      "h2_subtitle": "Explore convenient living at Joralemon Street Apartments near Belleville High School in Essex County, NJ, perfect for students and families.",
      "page_copy": "Discover Joralemon Street Apartments, ideally positioned near Belleville High School in Essex County, NJ. Our community is perfect for students and families looking for easy access to educational facilities. We offer a range of spacious one, two, and three-bedroom apartment options that combine style and practicality, making them perfect for any family size.\n\nOur apartments boast modern amenities that enhance daily living, including a fully equipped fitness center, dependable on-site parking, and lively resident activities. Enjoy a seamless lifestyle in a community that supports education and provides comfort, all while being conveniently close to Belleville High School. Joralemon Street Apartments is an exceptional choice for those seeking quality living near academic environments in Essex County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Belleville High School, Essex County",
      "seo_description": "Find modern apartments near Belleville High School at Joralemon Street with amenities perfect for students and families in Essex County, NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "belleville-middle-school-apartments-868",
      "search_query": "Belleville Middle School apartments",
      "category": "School",
      "h1_title": "Apartments Near Belleville Middle School",
      "h2_subtitle": "Joralemon Street Apartments offers convenient living near Belleville Middle School. Perfect for families seeking a community-focused lifestyle.",
      "page_copy": "Joralemon Street Apartments is the ideal choice for families in search of comfortable living near Belleville Middle School. Our community in Belleville, NJ offers a variety of stylish one, two, and three-bedroom floor plans, each designed to cater to modern family needs.\n\nSituated conveniently close to Belleville Middle School, our apartments make school commutes simple and efficient. Residents enjoy a wealth of amenities, including a state-of-the-art fitness center, ample on-site parking, and engaging resident events that foster community spirit. Experience a harmonious blend of convenience and comfort at Joralemon Street Apartments, making it the perfect home base for students and families alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Belleville Middle School, NJ",
      "seo_description": "Discover family-friendly living at Joralemon Street Apartments, conveniently located near Belleville Middle School, NJ with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "apartments-near-belleville-elementary-school-10-896",
      "search_query": "apartments near Belleville Elementary School 10",
      "category": "School",
      "h1_title": "Find Apartments Near Belleville Elementary 10",
      "h2_subtitle": "Joralemon Street Apartments provides ideal living near Belleville Elementary School 10. Perfect for families in Belleville, NJ.",
      "page_copy": "Looking for the perfect place to call home near Belleville Elementary School 10? Explore Joralemon Street Apartments, where families find a harmonious blend of community living and accessibility. Our site offers spacious one, two, and three-bedroom apartments tailored to meet the needs of growing families.\n\nLocated in Belleville, NJ, Joralemon Street Apartments ensures school is just a short walk or drive away, alleviating daily stress. Enjoy the convenience of modern amenities like a fully-equipped fitness center, reliable on-site parking, and vibrant resident activities that create a lively community atmosphere. Choose Joralemon Street Apartments for an enriching lifestyle near Belleville Elementary School 10.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Belleville Elementary School 10",
      "seo_description": "Discover convenient living at Joralemon Street Apartments, near Belleville Elementary School 10, offering modern amenities and ideal family-friendly features.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "belleville-elementary-school-4-nearby-housing-733",
      "search_query": "Belleville Elementary School 4 nearby housing",
      "category": "School",
      "h1_title": "Housing Near Belleville Elementary School 4",
      "h2_subtitle": "Explore Joralemon Street Apartments, providing excellent housing options near Belleville Elementary School 4 in Belleville, NJ.",
      "page_copy": "Joralemon Street Apartments offers prime housing solutions for those seeking proximity to Belleville Elementary School 4. Nestled in Belleville, NJ, our community provides a selection of beautifully renovated one, two, and three-bedroom apartments, ideal for families.\n\nEnjoy living in a family-friendly environment with amenities such as a modern fitness center, on-site parking, and engaging resident activities, all designed to enhance your lifestyle. Situated just moments away from Belleville Elementary School 4, Joralemon Street Apartments provides an unmatched convenience, making school commutes effortless and family life simpler. Choose us as your home base and experience living at its finest right next to Belleville Elementary School 4.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Belleville Elementary School 4",
      "seo_description": "Find comfortable housing at Joralemon Street Apartments near Belleville Elementary School 4, with family-friendly amenities in Belleville, NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "belleville-elementary-school-5-belleville-nj-apartments-837",
      "search_query": "Belleville Elementary School 5 Belleville NJ apartments",
      "category": "School",
      "h1_title": "Belleville NJ Apartments Near Elementary School 5",
      "h2_subtitle": "Discover Joralemon Street Apartments, ideally situated near Belleville Elementary School 5 in NJ—perfect for families seeking easy school access.",
      "page_copy": "Joralemon Street Apartments welcomes families seeking unmatched convenience near Belleville Elementary School 5 in Belleville, NJ. Choose from a variety of spacious and thoughtfully designed one, two, and three-bedroom floor plans that cater perfectly to modern family living.\n\nLocated within a short distance of Belleville Elementary School 5, our community simplifies daily routines by minimizing school commutes. Enjoy amenities such as a fitness center, on-site parking, and engaging resident activities that create a vibrant community atmosphere. Joralemon Street Apartments seamlessly blends comfort and convenience, making it the ideal choice for families looking to live near Belleville Elementary School 5.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Belleville NJ Apartments Near Elementary School 5",
      "seo_description": "Joralemon Street Apartments offer ideal living near Belleville Elementary School 5 in NJ, providing family-friendly amenities and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "st-peters-school-essex-county-rental-apartments-69",
      "search_query": "St Peter's School Essex County rental apartments",
      "category": "School",
      "h1_title": "Rental Apartments Near St Peter's School",
      "h2_subtitle": "Joralemon Street Apartments offers convenient rental living near St Peter's School in Essex County, perfect for families.",
      "page_copy": "Looking for the ideal rental apartments in Essex County near St Peter's School? Joralemon Street Apartments is your perfect match! Situated in Belleville, NJ, our community offers beautifully designed one, two, and three-bedroom apartments tailored for family comfort.\n\nWith amenities like a modern fitness center, reliable on-site parking, and interactive resident activities, you will quickly feel at home. Being just a short distance from St Peter's School, Joralemon Street Apartments ensures ease of access for busy families, making school commutes hassle-free. Experience a lifestyle of convenience and comfort in our family-friendly environment today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Apartments Near St Peter's School Essex County",
      "seo_description": "Find rental apartments at Joralemon Street Apartments near St Peter's School in Essex County, featuring modern amenities and great access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "apartments-near-clara-maass-medical-center-64",
      "search_query": "apartments near Clara Maass Medical Center Belleville",
      "category": "Hospital",
      "h1_title": "Apartments Near Clara Maass Medical Center",
      "h2_subtitle": "Choose Joralemon Street Apartments in Belleville, NJ, ideally located near Clara Maass Medical Center, for convenient living.",
      "page_copy": "Joralemon Street Apartments offers an exceptional living experience just moments from Clara Maass Medical Center in Belleville, NJ. Our spacious one, two, and three-bedroom apartments are perfect for professionals and families seeking proximity to this vital healthcare facility.\n\nEnjoy the convenience of being close to work while taking advantage of life-enhancing amenities such as a fitness center, on-site parking, and Wi-Fi in common areas. Our community ensures that everything you need is within reach, allowing you more time to focus on what truly matters. Choose Joralemon Street Apartments for a blend of comfort, convenience, and modern living near Clara Maass Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Clara Maass Medical Center",
      "seo_description": "Live at Joralemon Street Apartments near Clara Maass Medical Center in Belleville, NJ, offering modern amenities and convenient access for professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "apartments-near-belleville-park-nj-734",
      "search_query": "apartments near Belleville Park NJ",
      "category": "Park",
      "h1_title": "Apartments Near Belleville Park, NJ",
      "h2_subtitle": "Live at Joralemon Street Apartments, conveniently located near the beautiful Belleville Park in NJ, and enjoy scenic views.",
      "page_copy": "Discover Joralemon Street Apartments, a perfect residential community located conveniently near Belleville Park, NJ. Our beautifully designed one, two, and three-bedroom apartments offer modern living spaces with scenic views, ideal for nature enthusiasts.\n\nBeing just a stone's throw from Belleville Park provides endless outdoor recreation opportunities, making it easy to enjoy leisurely walks or a morning jog. At Joralemon Street Apartments, you will find amenities such as a fitness center, Wi-Fi in common areas, and engaging resident activities that complement your active lifestyle. Embrace a harmonious blend of nature and modern living by choosing Joralemon Street Apartments near Belleville Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Belleville Park, NJ",
      "seo_description": "Experience modern living at Joralemon Street Apartments near Belleville Park, NJ, with scenic views and easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "william-street-park-nearby-apartments-797",
      "search_query": "William Street Park nearby apartments",
      "category": "Park",
      "h1_title": "Apartments Near William Street Park",
      "h2_subtitle": "Joralemon Street Apartments offers comfortable living close to William Street Park, ideal for enjoying green spaces and outdoor activities.",
      "page_copy": "Joralemon Street Apartments provides the perfect blend of modern living and natural beauty, located just around the corner from William Street Park. Our one, two, and three-bedroom apartments offer renovated kitchens and comfortable living spaces, ideal for individuals and families alike.\n\nTake advantage of the proximity to William Street Park for endless outdoor activities. Whether you enjoy jogging, picnicking, or simply relaxing in a peaceful setting, this location is prime. With added perks like on-site parking, a fitness center, and engaging resident activities, Joralemon Street Apartments ensures a balanced lifestyle of convenience and leisure. Experience the best of both worlds near William Street Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near William Street Park",
      "seo_description": "Find comfortable apartments at Joralemon Street Apartments near William Street Park, offering modern amenities and easy access to outdoor activities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "branch-brook-park-belleville-rentals-193",
      "search_query": "Branch Brook Park Belleville rentals",
      "category": "Park",
      "h1_title": "Rentals Near Branch Brook Park, Belleville",
      "h2_subtitle": "Joralemon Street Apartments offers stunning rentals conveniently located near the picturesque Branch Brook Park in Belleville.",
      "page_copy": "Experience the charm of living near Branch Brook Park with rentals at Joralemon Street Apartments in Belleville. Our one, two, and three-bedroom options are designed with comfort and style in mind, offering ideal homes for those seeking proximity to the park's scenic beauty.\n\nBranch Brook Park is renowned for its expansive grounds and annual cherry blossom festival. Living nearby means easy access to the park's walking trails and natural vistas. At Joralemon Street Apartments, enjoy modern amenities such as a fitness center, Wi-Fi in common areas, and fun resident activities, all ensuring a well-rounded lifestyle. Choose Joralemon Street Apartments for the ideal park-side living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Branch Brook Park, Belleville",
      "seo_description": "Joralemon Street Apartments offers modern, spacious rentals near Branch Brook Park in Belleville, perfect for park enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "apartment-living-near-brookdale-park-531",
      "search_query": "apartment living near Brookdale Park",
      "category": "Park",
      "h1_title": "Apartment Living Near Brookdale Park",
      "h2_subtitle": "Enjoy the best of apartment living at Joralemon Street Apartments, perfectly located near Brookdale Park in the heart of Belleville.",
      "page_copy": "For those seeking serene apartment living near Brookdale Park, Joralemon Street Apartments is the ideal choice. Nestled in Belleville, NJ, our one, two, and three-bedroom apartments offer beautifully renovated spaces that combine comfort with modern convenience.\n\nBrookdale Park, famous for its lush landscapes and recreational areas, is just a short distance away, offering residents the perfect spot for weekend relaxation and outdoor activities. In addition to the park's proximity, our community features include a state-of-the-art fitness center, on-site parking, and a variety of resident activities to keep you engaged. Experience the harmony of nature and modern apartment living at Joralemon Street Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Living Near Brookdale Park",
      "seo_description": "Discover Joralemon Street Apartments, offering comfortable apartment living near Brookdale Park with great amenities in Belleville.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "watsessing-park-essex-county-apartments-795",
      "search_query": "Watsessing Park Essex County apartments",
      "category": "Park",
      "h1_title": "Essex County Apartments by Watsessing Park",
      "h2_subtitle": "Discover tranquil living at Joralemon Street Apartments, ideally located near Watsessing Park in Essex County, offering an array of amenities.",
      "page_copy": "Joralemon Street Apartments is your gateway to relaxed living near Watsessing Park in Essex County. Our stylish one, two, and three-bedroom floor plans are tailored for spacious comfort and modern elegance, perfect for those looking to settle in a vibrant neighborhood.\n\nJust a stone's throw from Watsessing Park, residents can enjoy the park's extensive trails and scenic spots for leisurely strolls, picnics, and outdoor fun. The community at Joralemon Street Apartments further enhances your lifestyle with convenient amenities such as a fitness center, Wi-Fi in common areas, and resident activities designed to foster a sense of community. Embrace the Essex County charm and natural beauty at Joralemon Street Apartments, where quality living meets a prime location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Essex County Apartments by Watsessing Park",
      "seo_description": "Find your new home at Joralemon Street Apartments near Watsessing Park, Essex County, offering modern living and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "rentals-near-reinheimer-park-belleville-585",
      "search_query": "rentals near Reinheimer Park Belleville",
      "category": "Park",
      "h1_title": "Rentals Near Reinheimer Park, Belleville",
      "h2_subtitle": "Find ideal rentals at Joralemon Street Apartments, just a short distance from the serene Reinheimer Park in Belleville.",
      "page_copy": "Joralemon Street Apartments provides the perfect setting for those seeking rentals near Reinheimer Park in Belleville. Our community offers beautifully designed one, two, and three-bedroom apartments, delivering both style and comfort.\n\nLiving near Reinheimer Park means you're close to a green oasis lauded for its tranquility and leisure spaces. Whether it's a morning jog or a relaxing picnic, the park is a fantastic amenity nearby. At Joralemon Street Apartments, enjoy numerous facilities including on-site parking, a fitness center, and pet-friendly spaces. Coupled with engaging resident activities, it's the ideal place to call home. Discover modern living amidst nature at Joralemon Street Apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Reinheimer Park, Belleville",
      "seo_description": "Discover Joralemon Street Apartments offering modern rentals near Reinheimer Park in Belleville. Enjoy great amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "yanticaw-park-nearby-apartments-nj-548",
      "search_query": "Yanticaw Park nearby apartments NJ",
      "category": "Park",
      "h1_title": "Yanticaw Park Nearby Apartments NJ",
      "h2_subtitle": "Explore Joralemon Street Apartments, conveniently located near Yanticaw Park, NJ, offering modern amenities and a welcoming community.",
      "page_copy": "Experience the charm of living near Yanticaw Park with Joralemon Street Apartments. Situated in Belleville, NJ, our community offers a selection of one, two, and three-bedroom apartments designed with modern comforts and conveniences.\n\nYanticaw Park is a short drive away, providing a peaceful retreat with its expansive green spaces, walking trails, and picturesque views—a perfect complement to our vibrant residential community. At Joralemon Street Apartments, you'll find amenities like a fully-equipped fitness center, resident activities, and pet-friendly policies. Enjoy the synergy of nature and contemporary living by choosing Joralemon Street Apartments as your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Yanticaw Park Nearby Apartments NJ",
      "seo_description": "Joralemon Street Apartments offers modern apartments near Yanticaw Park, NJ. Enjoy upscale amenities and a prime Belleville location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "apartments-near-silver-lake-belleville-155",
      "search_query": "apartments near Silver Lake Belleville",
      "category": "Transit",
      "h1_title": "Apartments Near Silver Lake, Belleville",
      "h2_subtitle": "Live close to Silver Lake at Joralemon Street Apartments. Enjoy the perfect blend of modern amenities and proximity to scenic beauty in Belleville.",
      "page_copy": "Located near the tranquil Silver Lake, Joralemon Street Apartments in Belleville offers an idyllic setting for those seeking a serene lifestyle with modern conveniences. Choose from our thoughtfully designed one, two, or three-bedroom layouts, each complemented by stylish finishes and comfortable living spaces.\n\nJust minutes away, Silver Lake provides an escape into nature with its soothing views and recreational activities. At Joralemon Street Apartments, residents benefit from a community atmosphere enriched with on-site parking, a fitness center, and access to Wi-Fi in common areas. Embrace lakeside tranquility while enjoying all the comforts of a welcoming apartment community at Joralemon Street Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Silver Lake, Belleville",
      "seo_description": "Discover Joralemon Street Apartments near Silver Lake, Belleville. Enjoy comfort and convenience with modern amenities and beautiful surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "belleville-apartments-close-to-grove-street-station-818",
      "search_query": "Belleville apartments close to Grove Street station",
      "category": "Transit",
      "h1_title": "Belleville Apartments Close to Grove St. Station",
      "h2_subtitle": "Discover the convenience of Joralemon Street Apartments, ideally situated near Grove Street Station. Enjoy easy commuting and modern amenities.",
      "page_copy": "Joralemon Street Apartments provide the perfect solution for those seeking Belleville apartments close to Grove Street station. Our community offers seamless access to public transportation, making daily commutes simple and stress-free.\n\nLocated just a short drive from Grove Street Station, our one, two, and three-bedroom apartments combine style with functionality. Residents enjoy a variety of amenities, including 24-hour emergency maintenance, a fitness center, and pet-friendly policies. With on-site parking and Wi-Fi in common areas, Joralemon Street Apartments ensure comfort and connectivity, ideal for those who value both convenience and quality living in Belleville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Belleville Apartments Close to Grove St. Station",
      "seo_description": "Joralemon Street Apartments offer modern living near Grove Street Station. Enjoy convenient commuting and excellent amenities in Belleville.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "davenport-avenue-transit-accessible-apartments-nj-07109-113",
      "search_query": "Davenport Avenue transit accessible apartments NJ 07109",
      "category": "Transit",
      "h1_title": "Davenport Avenue Transit Accessible Apartments",
      "h2_subtitle": "Joralemon Street Apartments offer transit-friendly living near Davenport Avenue. Enjoy a seamless commute in NJ 07109 with great home comforts.",
      "page_copy": "For those seeking transit accessible apartments in NJ 07109, Joralemon Street Apartments near Davenport Avenue provide the ideal solution. Our location ensures easy access to public transportation options, facilitating hassle-free travel around Belleville and beyond.\n\nWith beautifully designed one, two, and three-bedroom options, our apartments deliver comfort and style within a transit-friendly context. Residents enjoy modern amenities including a fitness center, resident activities, and on-site parking. At Joralemon Street Apartments, you'll find a vibrant community that supports both a convenient commute and a rich lifestyle. Discover the intersection of accessibility and home comfort here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Davenport Avenue Transit Accessible Apartments",
      "seo_description": "Find transit-friendly living at Joralemon Street Apartments near Davenport Avenue in NJ 07109. Enjoy easy commuting and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166325",
      "source": "custom",
      "page_item_url": "easy-airport-access-newark-liberty-apartments-650",
      "search_query": "easy airport access from Newark Liberty International Airport apartments",
      "category": "Transit",
      "h1_title": "Apartments with Easy Airport Access",
      "h2_subtitle": "Joralemon Street Apartments provide easy airport access from Newark Liberty International. Perfect for frequent travelers seeking comfort and convenience.",
      "page_copy": "For frequent flyers, Joralemon Street Apartments in Belleville offer ideal living with easy airport access from Newark Liberty International Airport. Situated to ensure a straightforward commute, our community grants peace of mind for those with travel-heavy schedules.\n\nOur one, two, and three-bedroom apartment homes feature stylish interiors and modern amenities such as a fitness center and Wi-Fi in common areas. Residents enjoy the luxury of convenience and comfort, all within a pet-friendly environment. With essential services nearby and a short drive to both transit hubs and the airport, Joralemon Street Apartments stand as a perfect choice for those prioritizing accessibility and quality living in NJ.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping.",
        "public_id": "01a015da-4f01-761c-b28c-2182974d91e6",
        "storage_key": "property/6767906449166325/01a015da-4f01-761c-b28c-2182974d91e6.webp",
        "width": 1688,
        "height": 1127
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Easy Airport Access, Belleville",
      "seo_description": "Enjoy easy access to Newark Liberty International Airport from Joralemon Street Apartments. Perfect for frequent travelers seeking modern comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5062"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976260008"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973396"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N78NPCQZ"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://joralemonapts.fatwin.com/api/websites/resources/1?x=MngvN2VGOGxOODJETjFOeHRyVG9TVTMrZGVJNVAxL2s3cktlMEloMFE1d0ZDbnE1MEtsMlp5ZEszTHc3VFRkWHFlZEpRQXVaRm5oZEI4aStHK3I2NUE9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "954a4880-43e6-11ef-8615-635f36f385d1"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954a4880-43e6-11ef-8615-635f36f385d1/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954a4880-43e6-11ef-8615-635f36f385d1/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImY0VVFYMlpNZVNwUG9oZ0FJQndYZFE9PSIsInZhbHVlIjoiOEZEd2V2V3BOQlQ1SXBaRjh3bnFJUT09IiwibWFjIjoiNjM3MjNiMDcwOWEwMjc3YzVlYzViZjAyY2IzZTFjOTYzNDVkOTY5ZDRiYzVhMmZjZGZlMjE4ZmFiMTI5MjYyMSJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5062",
  "custom_repli_id": "9976260008",
  "custom_realpage_id": "4973396",
  "custom_google_gtm_id": "GTM-N78NPCQZ",
  "custom_perq_script_url": "https://joralemonapts.fatwin.com/api/websites/resources/1?x=MngvN2VGOGxOODJETjFOeHRyVG9TVTMrZGVJNVAxL2s3cktlMEloMFE1d0ZDbnE1MEtsMlp5ZEszTHc3VFRkWHFlZEpRQXVaRm5oZEI4aStHK3I2NUE9PQ2",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "954a4880-43e6-11ef-8615-635f36f385d1",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954a4880-43e6-11ef-8615-635f36f385d1/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954a4880-43e6-11ef-8615-635f36f385d1/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImY0VVFYMlpNZVNwUG9oZ0FJQndYZFE9PSIsInZhbHVlIjoiOEZEd2V2V3BOQlQ1SXBaRjh3bnFJUT09IiwibWFjIjoiNjM3MjNiMDcwOWEwMjc3YzVlYzViZjAyY2IzZTFjOTYzNDVkOTY5ZDRiYzVhMmZjZGZlMjE4ZmFiMTI5MjYyMSJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "6937f27e-3a30-4c9a-a537-2d56dd04654b",
  "custom_audioeye_site_hash": "50ddf886cbf74a2b63fe8c5b71df2f84"
};

export const generatedAt = '2026-10-22T20:07:12.999Z';
